import React, { useEffect, useState, useCallback, useRef } from "react";
import altLogo from "../../assets/images/alt-logo.svg";
import altBankLogo from "../../assets/images/alt-finance-logo.svg";
import group1 from "../../assets/images/Group_1.svg";
import rightArrow from "../../assets/images/right_arrow.svg";
import no2 from "../../assets/images/no2.svg";
import no3 from "../../assets/images/no3.png";
import no4 from "../../assets/images/nos4.svg";
import copyButton from "../../assets/images/copy-button.svg";
import { useSelector } from "react-redux";
import "../../index.css";
import { useDispatch } from "react-redux";
import Icon_L from "../../assets/images/Icon_L.svg";
import success from "../../assets/images/success-icon.svg";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import Done from "../../assets/images/Done.svg";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/localStorage";
import axios from "axios";
import { baseBusinessUrl, baseUrl } from "../../utils/baseUrl";
import * as toast from "../../utils/makeToast";
import styles from "./style.module.css";
import {
  IEmploymentInfo,
  IMeansOfIdentification,
  IReligion,
  IBankBranch,
  IIndustry,
} from "../../models/IEnums.model";
import backArrow from "../../assets/images/backArrow.svg";
import { useNavigate } from "react-router-dom";
import uploadArrow from "../../assets/images/upload-arrow.svg";
import signEdit from "../../assets/images/signEdit.svg";
import signDelete from "../../assets/images/signDelete.svg";
import { Toaster } from "react-hot-toast";
import AuthCode from "react-auth-code-input";
import CountdownTimer from "../../customHooks/UseCOuntDownTImer";

import NewAddReference from "../../Components/BusinessForms/NewAddReference";
import CompanyDetailsForm from "./Components/CompanyDetailsForm";
import AddDirectors from "./Components/AddDirectors";
import NewCompanyDocumentUpload from "../../Components/BusinessForms/NewCompanyDocumentUpload";
import DatePicker from "react-datepicker";
import {
  links,
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
} from "../../utils/constants";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerComponent from "../../Components/DatePickerComponent";
import cbn from "../../assets/icons/cbn.svg";
import Loader from "../../Components/Loader";
import { encryptRequest } from "../../utils/encryption";
import useOtpResendCountdown from "../../customHooks/useOtpResendCountdown";
import SuccessIcon from "../../assets/icons/SuccessIcon";

function CompanyOpenAccount(props: any) {
  const navigate = useNavigate();
const {countdownStop,countdownStr,resetTimer} = useOtpResendCountdown()
  const navigateHome = () => {
    navigate("/");
  };
  const dispatch = useDispatch();
  const [tin, setTin] = useState("");
  const [universalID, setUnversalID] = useState("");
  const [signExtraFirstName, setSignExtraFirstName] = useState("");
  const [signExtraMiddleName, setSignExtraMiddleName] = useState("");
  const [signExtraLastName, setSignExtralastName] = useState("");
  const [signExtraPhoneNumber, setSignExtraPhoneNumber] = useState("");
  const [extradocument, setExtraDocument] = useState("");
  const [showExtraDocument, setShowExtraDocument] = useState(false);
  const [signatory, setSignatory] = useState(false);
  const [extraSignatory, setExtraSignatory] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [employmentInfos, setEmploymentInfos] = useState<IEmploymentInfo[]>([]);
  const [idCardtype, setIdCardType] = useState<any>("Permanent Voter's Card");
  const [bvnUpdateValidated, setBvnUpdateValidated] = useState(false);
  const [bvnNextUpdated, setBvnNextUpdated] = useState(false);
  const [bvnNextMandate, setBvnNextMandate] = useState(false);
  const [addDirector, setAddDirector] = useState(false);
  const [otp, setOtp] = useState("");
  const [accountName, setAccountName] = useState("");
  const [showTimer, setShowTimer] = useState(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );

  const copyAccountNumberToClipboard = (accountNumber: string) => {
    navigator.clipboard.writeText(accountNumber).then(
      function () {
        toast.successToast("Account number copied to clipboard");
      },
      function (err) {
        toast.successToast("Account number was not copied to clipboard");
      }
    );
  };

  const [single, setSingle] = useState(true);
  const [multiple, setMultiple] = useState(false);

  const [filledUpdatedDetails, setFilledUpdatedDetails] = useState(false);

  const [addedDirector, setAddedDirector] = useState([]);
  const [uploadDocumentSuccess, setUploadDocumentSuccess] = useState(false);
  const [allDirectors, setAllDirectors] = useState([]);
  const [tinPhoneNumber, setTinPhoneNumber] = useState("");
  const [showReferenceFormUpload, setShowReferenceFormUpload] = useState(false);
  const [referenceFormUpload, setReferenceFormUpload] = useState("");

  const getSingleTin = () => {
    if (tin?.length > 13 || tin?.length < 13) {
      setTinError(true);
      setValidateBtnLoading(false);
    } else {
      setValidateBtnLoading(true);
      axios.post(`${baseBusinessUrl}BusinessAccount/TinValidation`, { tin })
        
        .then((getresponse) => {
          if (getresponse.data.message == "not found") {
            setTinError(true);
            setValidateBtnLoading(false);
          } else if (
            getresponse.data.message == "Something went wrong, Please try again"
          ) {
            toast.errorToast(
              "Something went wrong while validating TIN, Please try again"
            );

            setValidateBtnLoading(false);
          } else if (!getresponse?.data?.UserDetails?.data?.rcNumber) {
            setTinError(true);
            setValidateBtnLoading(false);
          } else {
            setBusinessRegistrationNumber(
              getresponse.data.UserDetails.data.rcNumber
            );
            //  setTinPhoneNumber(getresponse.data.UserDetails.data.phone)
            setFullAddress(getresponse.data.UserDetails.data.address);

            validateTIN();
          }
        })
        .catch((err) => {
          
          setTinError(true);
          setValidateBtnLoading(false);
        });
    }
  };

  const handleVerifyOTP = useCallback(() => {
    let validateVerifyOtpPayload = {
      phoneNumber: tinPhoneNumber,
      otp: otp,
      bvn: "",
    };

    setValidating(true);
    setShowTimer(true);

    axios
      .post(
        `${baseBusinessUrl}Authentication/validateOTP`,
        validateVerifyOtpPayload
      )
      .then((newresponse) => {
        
        if (newresponse?.data?.accessToken?.length > 0) {
          let userInfo = getLocalStorageItem("userDetails") || {};

          setLocalStorageItem("accessToken", newresponse.data.accessToken);
          setLocalStorageItem(
            "jinx",
            JSON.stringify({
              refreshToken: newresponse.data.refreshToken,
              accessToken: newresponse.data.accessToken,
              accessTokenExpirationTime:
                newresponse.data.accessTokenExpirationTime,
              refreshTokenExpirationTime:
                newresponse.data.refreshTokenExpirationTime,
            })
          );
          setLocalStorageItem("userDetails", JSON.stringify({ ...userInfo }));

          axios
            .get(
              `${baseBusinessUrl}CompanyAccount/CompanyExistingDetails?Tin=${encryptRequest(
                tin
              )}`
            )
            .then((response) => {
              
              setBusinessName(response.data.businessName);
              setAccountName(response.data.businessName);
              setStreetNumber(response.data.streetNumber);
              setStreetName(response.data.streetName);
              setBusStop(response.data.nearestBustopLandmark);
              setArea(response.data.state);
              toast.successToast(newresponse.data.message);
              dispatch(setAccountOpeningStep("open-new-company-account"));
              setValidated(true);
              setValidating(false);
              setUnversalID(response.data.id);
              storeLoginTime();
              // getSingleTin();
              if (letx?.refreshTokenExpirationTime?.length > 0) {
                setShouldFetchData(true);
              }
            })
            .catch((err) => {
              toast.errorToast("something went wrong");

              
              setValidating(false);
            });
        } else {
          toast.errorToast(newresponse.data.message);

          setValidating(false);
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        
        setValidating(false);
      });
  }, [dispatch, tin, otp, tinPhoneNumber]);

  const addNewDirector = () => {
    let newDirectorPayload = {
      tin: tin,
      bvn: directorInputs.bvn,
      dateOfBirth: `${directorInputs.month}-${directorInputs.day}-${directorInputs.year}`,
      firstName: directorFirstName,
      secondName: directorMiddleName,
      lastName: directorLastName,
      phoneNumber: directorPhoneNumber,
      emailAddress: directorEmail,
      businessHouseNumber: signHouseNumber,
      businessStreetName: signStreetName,
      businessNearestBustop: signBusStop,
      businessState: signAreaState,
      businessNationality: 1,
      cerpacidNumber: signCerpacidNumber,
    };
    setBusinessSignatoryDetailsLoading(true);

    axios
      .post(
        `${baseBusinessUrl}CompanyDirector/CompanyDirectorDetails`,
        newDirectorPayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.message);

          setDirectorEmail("");
          setSignHouseNumber("");
          setSignStreetName(" ");
          setSignAreaState(" ");
          setSignBusStop(" ");
          setSignCerpacidNumber(" ");

          setAddDirector(false);
          axios
            .get(
              `${baseBusinessUrl}CompanyDirector/CompanyDirectorGetAllDetails?Tin=${encodeURIComponent (encryptRequest(
                tin
              ) as string)}`
            )
            .then((response) => {
              setAllDirectors(response.data);
            })
            .catch((err) => {
              
            });
        } else {
          toast.errorToast(response.data.message);
        }
        

        setBusinessSignatoryDetailsLoading(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setBusinessSignatoryDetailsLoading(false);
      });
  };

  const newDirectorAddded = () => {
    dispatch(setAccountOpeningStep("upload-document"));
  };

  const previousNewDirectorAdded = () => {
    dispatch(setAccountOpeningStep("open-new-company-account"));
  };

  //For bvn validation

  const [inputs, setInputs] = useState<any>({});
  const [directorInputs, setDirectorInputs] = useState<any>({});
  const [extraInputs, setExtraInputs] = useState<any>({});

  const [bvnValidating, setBvnValidating] = useState(false);
  const [days, setDays] = useState<string[]>([]);
  const [months, setMonths] = useState<string[]>([]);
  const [years, setYears] = useState<string[]>([]);
  const [bvnClose, setBvnClose] = useState(true);

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  const handleDirectorChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setDirectorInputs((values: any) => ({ ...values, [name]: value }));
  };

  const handleExtraChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setExtraInputs((values: any) => ({ ...values, [name]: value }));
  };

  const [businessSignatoryDetailsLoading, setBusinessSignatoryDetailsLoading] =
    useState(false);
  const [signFirstName, setSignFirstName] = useState(userDetails.firstName);
  const [signMiddleName, setSignMiddleName] = useState(userDetails.middleName);
  const [signLastName, setSignLastName] = useState(userDetails.lastName);
  const [signPhoneNumber, setSignPhoneNumber] = useState(
    userDetails.phoneNumber
  );
  const [signDob, setSignDob] = useState(
    `${inputs.month}-${inputs.day}-${inputs.year}`
  );
  const referenceFormPdf = require("../../assets/pdf/reference_form_nib.pdf");
  const termsAndConditionPdf = require("../../assets/pdf/tac.pdf");
  const [signEmailAddress, setSignEmailAddress] = useState("");
  const [signHouseNumber, setSignHouseNumber] = useState("");
  const [signStreetName, setSignStreetName] = useState("");
  const [signAreaState, setSignAreaState] = useState("");
  const [signBusStop, setSignBusStop] = useState("");
  const [signAddress, setSignAddress] = useState("");
  const [signReligion, setSignReligion] = useState("");
  const [signNationality, setSignNationality] = useState("");
  const [signIdentityCardType, setSignIdentityCardType] = useState("");
  const [signIdCardNumber, setSignIdCardNumber] = useState("");
  const [signIssueDate, setSignIssueDate] = useState(new Date());
  const [signExpiryDate, setSignExpiryDate] = useState(new Date());
  const [signReferralCode, setSignReferralCode] = useState("");
  const [signIdCardName, setSignIdCardName] = useState("");
  const [signCerpacidNumber, setSignCerpacidNumber] = useState("");
  const [directorFirstName, setDirectorFirstName] = useState("");
  const [directorMiddleName, setDirectorMiddleName] = useState("");
  const [directorLastName, setDirectorLastName] = useState("");
  const [directorPhoneNumber, setDirectorPhoneNumber] = useState("");
  const [directorEmail, setDirectorEmail] = useState("");

  const [deleteSignatoryModal, setDeleteSignatoryModal] = useState(false);
  const [deleteSignatoryModalExtra, setDeleteSignatoryModalExtra] =
    useState(false);
  const [confirmDeleteSignatoryModal, setConfirmDeleteSignatoryModal] =
    useState(false);
  const [
    confirmDeleteSignatoryModalExtra,
    setConfirmDeleteSignatoryModalExtra,
  ] = useState(false);

  const nationalityData = [
    {
      id: 1,
      name: "Nigerian",
    },
    {
      id: 2,
      name: "Not Nigerian",
    },
  ];

  const addreference = () => {
    dispatch(setAccountOpeningStep("add-reference"));
  };

  const businessSignatoryDetails = () => {
    let businessSignatoryPayload = {
      tin: tin,
      signatoryBvn: inputs.bvn,
      signatoryDateOfBirth: `${inputs.month}-${inputs.day}-${inputs.year}`,
      firstName: signFirstName,
      secondName: signMiddleName,
      lastName: signLastName,
      phoneNumber: signPhoneNumber,
      emailAddress: signEmailAddress,
      businessHouseNumber: signHouseNumber,
      businessStreetName: signStreetName,
      businessNearestBustop: signBusStop,
      businessState: signAreaState,
      businessNationality: 2,
      cerpacidNumber: signCerpacidNumber,
      // identityCardType: idCardtype,
      identityCardType: "5",
      iDcardNumber: signIdCardNumber,
      issuedDate: signIssueDate,
      expiryDate: signExpiryDate,
      iDcardName: signIdCardName,
    };
    setBusinessSignatoryDetailsLoading(true);

    axios
      .post(
        `${baseBusinessUrl}CompanySignatoryAccount/CompanySignatoryDetails`,
        businessSignatoryPayload
      )
      .then((response) => {
        setSignatoryId(response.data.obj.id);
        
        if (
          signHouseNumber?.length < 1 ||
          signEmailAddress?.length < 1 ||
          signStreetName?.length < 1 ||
          signBusStop?.length < 1 ||
          signAreaState?.length < 1 ||
          signIdCardNumber?.length < 1 ||
          signIdCardName?.length < 1
        ) {
          toast.errorToast(
            "All required fields should be filed up before moving to the next stage"
          );
        } else if (response.data.isSuccess) {
          toast.successToast(response.data.message);
          setBvnNextMandate(true);
          setBvnNextUpdated(false);
        } else {
          toast.errorToast(response.data.message);
        }

        setBusinessSignatoryDetailsLoading(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setBusinessSignatoryDetailsLoading(false);
      });
  };

  const businessSignatoryExtraDetails = () => {
    let businessSignatoryPayload = {
      tin: tin,
      signatoryBvn: extraInputs.bvn,
      signatoryDateOfBirth: `${extraInputs.month}-${extraInputs.day}-${extraInputs.year}`,
      firstName: userDetails.extrafirstname,
      secondName: userDetails.extralastName,
      lastName: userDetails.extralastName,
      phoneNumber: userDetails.extraphoneNumber,
      emailAddress: signEmailAddress,
      businessHouseNumber: signHouseNumber,
      businessStreetName: signStreetName,
      businessNearestBustop: signBusStop,
      businessState: signAreaState,
      businessNationality: 2,
      cerpacidNumber: signCerpacidNumber,
      // identityCardType: idCardtype,
      identityCardType: "5",
      iDcardNumber: signIdCardNumber,
      issuedDate: signIssueDate,
      expiryDate: signExpiryDate,
      iDcardName: signIdCardName,
    };
    setBusinessSignatoryDetailsLoading(true);

    axios
      .post(
        `${baseBusinessUrl}CompanySignatoryAccount/CompanySignatoryDetails`,
        businessSignatoryPayload
      )
      .then((response) => {
        
        setSignatoryId(response.data.obj.id);
        if (
          signHouseNumber.length < 1 ||
          signEmailAddress.length < 1 ||
          signStreetName.length < 1 ||
          signBusStop.length < 1 ||
          signAreaState.length < 1 ||
          signIdCardNumber.length < 1 ||
          signIdCardName.length < 1
        ) {
          toast.errorToast(
            "All required fields should be filed up before moving to the next stage"
          );
        } else if (response.data.isSuccess) {
          toast.successToast(response.data.message);
          setBvnNextMandate(true);
          setBvnNextUpdated(false);
        } else {
          toast.errorToast(response.data.message);
        }

        setBusinessSignatoryDetailsLoading(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setBusinessSignatoryDetailsLoading(false);
      });
  };

  const handleValidateBVN = () => {
    if (checkFormValidity()) {
      validateBVN();
    } else {
      toast.errorToast("INVALID BVN OR DATE OF BIRTH");
    }
  };

  const validateBVN = () => {
    let validateBVNPayload = {
      bvn: inputs.bvn,
      dateOfBirth: `${inputs.month}-${inputs.day}-${inputs.year}`,
    };
    let userDetails = getLocalStorageItem("userDetails") || {};
    setLocalStorageItem(
      "userDetails",
      JSON.stringify({ ...userDetails, bvn: inputs.bvn })
    );

    setBvnValidating(true);
    axios
      .post(
        `${baseBusinessUrl}Authentication/BvnDateOfBirthValidationWithoutOTP`,
        validateBVNPayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.responseMessage);
          setSignFirstName(response.data.firstName);
          setSignMiddleName(response.data.middleName);
          setSignLastName(response.data.lastName);
          setSignPhoneNumber(response.data.phoneNumber);
          setBvnNextUpdated(true);
          setBvnClose(false);

          setBvnUpdateValidated(true);
        } else {
          toast.errorToast(response.data.responseMessage);
        }
        setBvnValidating(false);
      })
      .catch((err) => {
        toast.errorToast("INVALID BVN OR DATE OF BIRTH");
        
        setBvnValidating(false);
      });
  };

  const validateDirectorBVN = () => {
    let validateBVNPayload = {
      bvn: directorInputs.bvn,
      dateOfBirth: `${directorInputs.month}-${directorInputs.day}-${directorInputs.year}`,
    };
    let userDetails = getLocalStorageItem("userDetails") || {};
    setLocalStorageItem(
      "userDetails",
      JSON.stringify({ ...userDetails, bvn: directorInputs.bvn })
    );

    setBvnValidating(true);
    axios
      .post(
        `${baseBusinessUrl}Authentication/BvnDateOfBirthValidationWithoutOTP`,
        validateBVNPayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.responseMessage);
          setDirectorFirstName(response.data.firstName);
          setDirectorMiddleName(response.data.middleName);
          setDirectorLastName(response.data.lastName);
          setDirectorPhoneNumber(response.data.phoneNumber);
          setBvnNextUpdated(true);
          setBvnClose(false);

          setBvnUpdateValidated(true);
        } else {
          toast.errorToast(response.data.responseMessage);
        }
        setBvnValidating(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setBvnValidating(false);
      });
  };

  const validateExtraBVN = () => {
    let validateBVNPayload = {
      bvn: extraInputs.bvn,
      dateOfBirth: `${extraInputs.month}-${extraInputs.day}-${extraInputs.year}`,
    };
    // let userDetails = getLocalStorageItem("userDetails") || {};
    // setLocalStorageItem(
    //   "userDetails",
    //   JSON.stringify({ ...userDetails, bvn: inputs.bvn })
    // );

    setBvnValidating(true);
    axios
      .post(
        `${baseBusinessUrl}Authentication/BvnDateOfBirthValidationWithoutOTP`,
        validateBVNPayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.responseMessage);
          setSignExtraFirstName(response.data.firstName);
          setSignExtralastName(response.data.lastName);
          setSignExtraMiddleName(response.data.middleName);
          setSignExtraPhoneNumber(response.data.phoneNumber);
          setBvnNextUpdated(true);
          setBvnClose(false);

          setBvnUpdateValidated(true);

          setBvnUpdateValidated(true);
        } else {
          toast.errorToast(response.data.responseMessage);
        }
        setBvnValidating(false);
      })
      .catch((err) => {
        toast.errorToast("INVALID BVN OR DATE OF BIRTH");
        
        setBvnValidating(false);
      });
  };

  const checkFormValidity = () => {
    if (
      inputs?.bvn?.length < 11 ||
      inputs?.bvn?.length > 11 ||
      !inputs?.day ||
      !inputs?.month ||
      !inputs?.year
    ) {
      return false;
    } else {
      return true;
    }
  };

  const setDOBValues = () => {
    let calculatedYears = [];

    setDays([
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ]);

    setMonths([
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]);

    for (let i = 1900; i < new Date().getFullYear(); i++) {
      calculatedYears.push(`${i}`);
    }

    setYears([...calculatedYears]);
  };

  useEffect(() => {
    dispatch(setAccountOpeningStep("tin-validation"));
    // dispatch(setAccountOpeningStep("upload-document"));
    getMeansOfIdentification();
    getReligions();
    setDOBValues();
  }, []);

  const letx = getLocalStorageItem("jinx");

  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [loginTime, setLoginTime] = useState("");

  const storeLoginTime = () => {
    const currentDate = new Date();
    const formattedDateTime = currentDate.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

    setLoginTime(formattedDateTime);
  };

  

  useEffect(() => {
    if (shouldFetchData) {
      const hasPassedDateTime = (
        targetDateTimeString,
        referenceDateTimeString
      ) => {
        const targetDateTime = new Date(targetDateTimeString);
        const referenceDateTime = new Date(referenceDateTimeString);
        return referenceDateTime > targetDateTime;
      };

      const hasPassed = hasPassedDateTime(
        letx.accessTokenExpirationTime,
        loginTime
      );
      const hasrefreshPassed = hasPassedDateTime(
        letx.refreshTokenExpirationTime,
        loginTime
      );
      

      if (hasPassed) {
        let newTokenPayload = {
          refreshToken: letx.refreshToken,
          accessToken: letx.accessToken,
        };
        axios
          .post(
            `${baseBusinessUrl}Authentication/RefreshToken`,
            newTokenPayload
          )
          .then((response) => {
            
            setLocalStorageItem("accessToken", response.data.accessToken);
          })
          .catch((err) => {
            
          });
      }
      if (hasrefreshPassed) {
        dispatch(setAccountOpeningStep("tin-validation"));
      }
    }
  }, [letx, dispatch, setAccountOpeningStep, shouldFetchData, loginTime]);

  const clickSingle = () => {
    setSingle(true);
    setMultiple(false);
  };

  const clickMultiple = () => {
    setSingle(false);
    setMultiple(true);
  };

  const [result, setResult] = useState("");
  const handleOnChange = (res: string) => {
    setOtp(res);
  };

  const [validating, setValidating] = useState(false);

  // const { accountType } = useSelector((state) => state.accountOpeningData)
  const { accountOpeningStep } = useSelector(
    (state: any) => state.accountOpeningData
  );

  const [validated, setValidated] = useState(false);
  const [updateDetailsX, setUpdateDetailsX] = useState(false);
  const [completeSignUpdate, setComplteSignUpdate] = useState(false);
  const [responseBvn, setResponseBvn] = useState("");

  //signatory code

  const [meansOfIdentification, setMeansOfIdentification] = useState<
    IMeansOfIdentification[]
  >([]);

  const [signUpdateDetails, setSignUpdateDetails] = useState(false);

  const getMeansOfIdentification = () => {
    axios
      .get(`${baseBusinessUrl}Enum/MeansOfIdentification`)
      .then((response) => {
        setMeansOfIdentification(response.data);
      })
      .catch((err) => {
        
      });
  };

  const [getReligion, setReligion] = useState([]);

  const getReligions = () => {
    axios
      .get(`${baseBusinessUrl}Enum/Religion`)
      .then((response) => {
        setReligion(response.data);
      })
      .catch((err) => {
        
      });
  };

  const handleSetIdCardType = (id: any) => {
    setIdCardType(id);
  };

  //For TIN Validation

  const openSignatory = () => {
    setSignatory(true);
    setBvnClose(true);
    setBvnNextMandate(false);
    setIsDirectorOpen(false);
  };

  const [isDirectorOpen, setIsDirectorOpen] = useState(false);

  const openDirectorSignatory = () => {
    setAddDirector(true);
    setBvnClose(true);
    setBvnNextMandate(false);
    setIsDirectorOpen(true);
    setBvnNextUpdated(false);

    setDirectorInputs({});
  };

  const closeDirectorSignatory = () => {
    setAddDirector(false);
    setBvnClose(false);
    setBvnNextMandate(false);
  };

  const openExtraSigntory = () => {
    setExtraSignatory(true);
    setBvnClose(true);
    setBvnNextMandate(false);
    setBvnNextUpdated(false);

    setInputs({});
  };

  const [taxOfficeName, setTaxOfficeName] = useState("");

  const [existingAccountNumber, setExistingAccountNumber] = useState("");
  const [customerName, setCustomerName] = useState("");

  const validateTIN = () => {
    // let validateTinPayload = {
    //   tin: tin,
    //   accountNumber: existingAccountNumber,
    //   bvn: responseBvn,
    // };
    let validateTinPayload = {
      tin: tin,
      accountNumber: existingAccountNumber,
    };

    if (
      tin?.length > 13 ||
      tin?.length < 13 ||
      existingAccountNumber?.length < 10 ||
      existingAccountNumber?.length > 10
    ) {
      setTinError(true);
      setValidateBtnLoading(false);
    } else {
      setValidateBtnLoading(true);
      // axios
      //   .get(
      //     `${baseBusinessUrl}/BusinessAccount/TinAccountNumberValidion?Tin=${encryptRequest(tin)}&accountNumber=${encryptRequest(existingAccountNumber)}`
      //   )
      axios
        .post(
          `${baseBusinessUrl}/BusinessAccount/TinAccountNumberValidion`,
          validateTinPayload
        )
        .then((response) => {
          
          if (
            response.data.responseMessage === "Error validating account number"
          ) {
            toast.errorToast("Error validating account number");
          } else if (response.data.isSuccess) {
            setTinPhoneNumber(response.data.phoneNumber);
            // setFullAddress(response.data.businessAddress);
            toast.successToast(response.data.responseMessage);
            setCustomerName(response.data.accountDetails.acC_NAME);
            setResponseBvn(response.data.accountDetails.bvn);
            dispatch(setAccountOpeningStep("otp"));
            setValidateBtnLoading(false);
            
          }
          setValidateBtnLoading(false);
        })
        .catch((err) => {
          setTinError(true);
          
          setValidateBtnLoading(false);
        });
    }
  };

  const reSendOTP = () => {
    let sendOTPPayload = {
      phoneNumber: tinPhoneNumber,
      customerName: customerName,
      bvn: responseBvn,
    };
    
    setShowTimer(true);

    axios
      .post(`${baseBusinessUrl}Authentication/SendOTP`, sendOTPPayload)
      .then((newresponse) => {
        

        if (newresponse.data.isSuccess) {
          toast.successToast(newresponse.data.message);

          toast.successToast("OTP resent to your email or phone number");

          setValidateBtnLoading(false);
          setValidated(true);
          resetTimer()
        } else {
          toast.successToast("OTP not sent, Please try again Later");
        }
      })
      .catch((err) => {
        setTinError(true);
        
        setValidateBtnLoading(false);
      });
  };

  const [validateBtnLoading, setValidateBtnLoading] = useState(false);

  // for signing popup upload documents ========================================

  const [uploadSignature, setUploadSignature] = useState("");
  const [showUploadSignature, setShowUploadSignature] = useState(false);
  const [businessSignature, setBusinessSignature] = useState("");
  const [showBusinessSignature, setShowBusinessSignature] = useState(false);
  const [uploadScannedID, setUploadScannedID] = useState("");
  const [showUploadScannedID, setShowUploadScannedID] = useState(false);
  const [utilityBill, setUtilityBill] = useState("");
  const [showUtilityBill, setShowUtilityBill] = useState(false);
  const [mandate, setMandate] = useState("");
  const [businessResolution, setBusinessResolution] = useState("");
  const [showBusinessResolution, setShowBusinessResolution] = useState(false);
  const [othersDocument, setOthersDocument] = useState("");
  const [showOthersDocument, setShowOthersDocument] = useState(false);
  const [cacDocument, setCacDocument] = useState("");
  const [showCacDocument, setShowCacDocument] = useState(false);
  const [cac1Document, setCac1Document] = useState("");
  const [showCac1Document, setShowCac1Document] = useState(false);
  const [co2Document, setCo2Document] = useState("");
  const [showCo2Document, setShowCo2Document] = useState(false);
  const [co7Document, setCo7Document] = useState("");
  const [showCo7Document, setShowCo7Document] = useState(false);
  const [memartDocument, setMemartDocument] = useState("");
  const [showMemartDocument, setShowMemartDocument] = useState(false);

  // const uploadImage = (payload: any, type: string) => {
  //   if (type === "signature") {
  //     setShowUploadSignature(true);
  //     setUploadSignature(payload.postedFilebase64);
  //   }

  //   if (type === "BusinessName") {
  //     setShowBusinessSignature(true);
  //     setBusinessSignature(payload.postedFilebase64);
  //   }

  //   if (type === "scannedID") {
  //     setShowUploadScannedID(true);
  //     setUploadScannedID(payload.postedFilebase64);
  //   }

  //   if (type === "businessResolution") {
  //     setShowBusinessResolution(true);
  //     setBusinessResolution(payload.postedFilebase64);
  //   }

  //   if (type === "referenceFormRealUpload") {
  //     setShowReferenceFormUpload(true);
  //     setReferenceFormUpload(payload.postedFilebase64);
  //   }

  //   if (type === "othersDocument") {
  //     setShowOthersDocument(true);
  //     setOthersDocument(payload.postedFilebase64);
  //   }

  //   if (type === "cac") {
  //     setCacDocument(payload.postedFilebase64);
  //     setShowCacDocument(true);
  //   }
  //   if (type === "cac1") {
  //     setCac1Document(payload.postedFilebase64);
  //     setShowCac1Document(true);
  //   }
  //   if (type === "co2") {
  //     setCo2Document(payload.postedFilebase64);
  //     setShowCo2Document(true);
  //   }
  //   if (type === "co7") {
  //     setCo7Document(payload.postedFilebase64);
  //     setShowCo7Document(true);
  //   }
  //   if (type === "memert") {
  //     setMemartDocument(payload.postedFilebase64);
  //     setShowMemartDocument(true);
  //   }
  // };

  const [documentLoader, setDocumentLoader] = useState(false);
  const uploadImage = (payload: any, type: string) => {
    if (type === "signature") {
      setShowUploadSignature(false);
      setUploadSignature(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "BusinessName") {
      setShowBusinessSignature(false);
      setBusinessSignature(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "scannedID") {
      setShowUploadScannedID(false);
      setUploadScannedID(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "utilityBill") {
      setShowUtilityBill(false);
      setUtilityBill(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "businessResolution") {
      setShowBusinessResolution(false);
      setBusinessResolution(payload.postedFilebase64);
      setDocumentLoader(true);
    }

    // else if (type === "combo2BusinessResolution") {
    //   setShowCombo2BusinessResolution(false);
    //   setCombo2BusinessResolution(payload.postedFilebase64);
    //   setDocumentLoader(true)
    // }
    else if (type === "othersDocument") {
      setShowOthersDocument(false);
      setOthersDocument(payload.postedFilebase64);
      setDocumentLoader(true);
    }
    // else if (type === "otherscombo2Document") {
    //   setShowcombo2OthersDocument(false);
    //   setcombo2OthersDocument(payload.postedFilebase64);
    //   setDocumentLoader(true)
    // }
    else if (type === "referenceFormRealUpload") {
      setShowReferenceFormUpload(false);
      setReferenceFormUpload(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "cac") {
      if (payload.filetype !== "pdf") {
        toast.errorToast("Please Upload only PDF File Format Documents");
      } else {
        setCacDocument(payload.postedFilebase64);
        setShowCacDocument(false);
        setDocumentLoader(true);
      }
    }

    // else if (type === "combo2Cac") {
    //   if (payload.filetype !== "pdf") {
    //     toast.errorToast("Please Upload only PDF File Format Documents");
    //   } else {
    //     setCombo2CacDocument(payload.postedFilebase64);
    //     setShowCombo2CacDocument(false)
    //     setDocumentLoader(true);
    //   }
    // }
    else if (type === "cac1") {
      if (payload.filetype !== "pdf") {
        toast.errorToast("Please Upload only PDF File Format Documents");
      } else {
        setCac1Document(payload.postedFilebase64);
        setShowCac1Document(false);
        setDocumentLoader(true);
      }
    } else if (type === "co2") {
      if (payload.filetype !== "pdf") {
        toast.errorToast("Please Upload only PDF File Format Documents");
      } else {
        setCo2Document(payload.postedFilebase64);
        setShowCo2Document(false);
        setDocumentLoader(true);
        
      }
    } else if (type === "co7") {
      if (payload.filetype !== "pdf") {
        toast.errorToast("Please Upload only PDF File Format Documents");
      } else {
        setCo7Document(payload.postedFilebase64);
        setShowCo7Document(false);
        setDocumentLoader(true);
      }
    } else if (type === "memert") {
      if (payload.filetype !== "pdf") {
        toast.errorToast("Please Upload only PDF File Format Documents");
      } else {
        setMemartDocument(payload.postedFilebase64);
        setShowMemartDocument(false);
        setDocumentLoader(true);
      }
    }
    // else if (type === "combo2memert") {
    //   if (payload.filetype !== "pdf") {
    //     toast.errorToast("Please Upload only PDF File Format Documents");
    //   } else {
    //     setCombo2MemartDocument(payload.postedFilebase64);
    //     setShowCombo2MemartDocument(false);
    //     setDocumentLoader(true)
    //   }
    // }
    else if (type === "extraDocument") {
      if (payload.filetype !== "pdf") {
        toast.errorToast("Please Upload only PDF File Format Documents");
      } else {
        setShowExtraDocument(false);
        setExtraDocument(payload.postedFilebase64);
        setDocumentLoader(true);
      }
    }
    // else if (type === "extracombo2Document") {
    //   if (payload.filetype !== "pdf") {
    //     toast.errorToast("Please Upload only PDF File Format Documents");
    //   } else {
    //     setShowcombo2ExtraDocument(false);
    //     setcombo2ExtraDocument(payload.postedFilebase64);
    //     setDocumentLoader(true)
    //   }
    // }
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        
        
        if (response.data.isSuccess) {
          if (type === "signature") {
            setShowUploadSignature(true);
            setUploadSignature(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "BusinessName") {
            setShowBusinessSignature(true);
            setBusinessSignature(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "utilityBill") {
            setShowUtilityBill(true);
            setUtilityBill(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "scannedID") {
            setShowUploadScannedID(true);
            setUploadScannedID(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "businessResolution") {
            setShowBusinessResolution(true);
            setBusinessResolution(response.data?.id);
            setDocumentLoader(false);
          }

          // else if (type === "combo2BusinessResolution") {
          //   setShowCombo2BusinessResolution(true);
          //   setCombo2BusinessResolution(response.data?.id);
          //   setDocumentLoader(false)
          // }
          else if (type === "othersDocument") {
            setShowOthersDocument(true);
            setOthersDocument(response.data?.id);
            setDocumentLoader(false);
          }
          // else if (type === "otherscombo2Document") {
          //   setShowcombo2OthersDocument(true);
          //   setcombo2OthersDocument(response.data?.id);
          //   setDocumentLoader(false)
          // }
          else if (type === "referenceFormRealUpload") {
            setShowReferenceFormUpload(true);
            setReferenceFormUpload(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "cac") {
            if (payload.filetype !== "pdf") {
              toast.errorToast("Please Upload only PDF File Format Documents");
            } else {
              setCacDocument(response.data?.id);
              setShowCacDocument(true);
              setDocumentLoader(false);
            }
          }

          // else if (type === "combo2Cac") {
          //   if (payload.filetype !== "pdf") {
          //     toast.errorToast("Please Upload only PDF File Format Documents");
          //   } else {
          //     setCombo2CacDocument(response.data?.id);
          //     setShowCombo2CacDocument(true)
          //     setDocumentLoader(false);
          //   }
          // }
          else if (type === "cac1") {
            if (payload.filetype !== "pdf") {
              toast.errorToast("Please Upload only PDF File Format Documents");
            } else {
              setCac1Document(response.data?.id);
              setShowCac1Document(true);
              setDocumentLoader(false);
            }
          } else if (type === "co2") {
            if (payload.filetype !== "pdf") {
              toast.errorToast("Please Upload only PDF File Format Documents");
            } else {
              setCo2Document(response.data?.id);
              setShowCo2Document(true);
              setDocumentLoader(false);
              
            }
          } else if (type === "co7") {
            if (payload.filetype !== "pdf") {
              toast.errorToast("Please Upload only PDF File Format Documents");
            } else {
              setCo7Document(response.data?.id);
              setShowCo7Document(true);
              setDocumentLoader(false);
            }
          } else if (type === "memert") {
            if (payload.filetype !== "pdf") {
              toast.errorToast("Please Upload only PDF File Format Documents");
            } else {
              setMemartDocument(response.data?.id);
              setShowMemartDocument(true);
              setDocumentLoader(false);
            }
          }
          // else if (type === "combo2memert") {
          //   if (payload.filetype !== "pdf") {
          //     toast.errorToast("Please Upload only PDF File Format Documents");
          //   } else {
          //     setCombo2MemartDocument(response.data?.id);
          //     setShowCombo2MemartDocument(true);
          //     setDocumentLoader(false)
          //   }
          // }
          else if (type === "extraDocument") {
            if (payload.filetype !== "pdf") {
              toast.errorToast("Please Upload only PDF File Format Documents");
            } else {
              setShowExtraDocument(true);
              setExtraDocument(response.data?.id);
              setDocumentLoader(false);
            }
          }
          // else if (type === "extracombo2Document") {
          //   if (payload.filetype !== "pdf") {
          //     toast.errorToast("Please Upload only PDF File Format Documents");
          //   } else {
          //     setShowcombo2ExtraDocument(true);
          //     setcombo2ExtraDocument(response.data?.id);
          //     setDocumentLoader(false)
          //   }
          // }
        } else {
          toast.errorToast("Unable to Save File");
          setDocumentLoader(false);
        }
      })
      .catch((err) => {
        setDocumentLoader(false);
        
        setShowUploadSignature(false);
        setShowBusinessSignature(false);
        setShowUploadScannedID(false);
        setShowBusinessResolution(false);
        // setShowCombo2BusinessResolution(false)
        setShowOthersDocument(false);
        // setShowcombo2OthersDocument(false)
        setShowReferenceFormUpload(false);
        setShowCacDocument(false);
        // setShowCombo2CacDocument(false)
        setShowCac1Document(false);
        setShowCo2Document(false);
        setShowCo7Document(false);
        setShowMemartDocument(false);
        // setShowCombo2MemartDocument(false)
        setShowExtraDocument(false);
        // setShowcombo2ExtraDocument(false)

        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  // const handleImageSubmit = (type: string) => {
  //   uploadImage(fileUploadObj, type);
  // };

  // let fileUploadObj: any;

  // const convertToBase64 = (file: any) => {
  //   return new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);
  //     fileReader.onload = () => {
  //       let fileReaderResult = fileReader.result?.toString();
  //       if (
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "png" ||
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "jpg" ||
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "pdf"
  //       ) {
  //         return resolve(fileReaderResult?.substring(22));
  //       } else if (
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "jpeg"
  //       ) {
  //         return resolve(fileReaderResult?.substring(23));
  //       }
  //     };
  //     fileReader.onerror = (error) => {
  //       reject(error);
  //     };
  //   });
  // };

  // const handleFileUpload = async (e: any, type: string) => {
  //   const file = e.target.files[0];
  //   let fileSize = file.size / 1000;
  //   if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
  //     toast.errorToast(
  //       `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`
  //     );
  //     return;
  //   }
  //   let base64: any;

  //   convertToBase64(file).then((res) => {
  //     base64 = res;
  //     fileUploadObj = {
  //       postedFilebase64: res,
  //       documentName: type,
  //       filetype: file.type.split("/")[1],
  //     };
  //     handleImageSubmit(type);
  //   });
  // };
  const handleImageSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  let fileUploadObj: any;

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let fileReaderResult = fileReader.result?.toString();
        return resolve(fileReaderResult);
        // if (
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "png" ||
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "jpg" ||
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "pdf"
        // ) {
        //   return resolve(fileReaderResult?.substring(22));
        // } else if (
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "jpeg"
        // ) {
        //   return resolve(fileReaderResult?.substring(23));
        // }
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let fileSize = file.size / 1000;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      

      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }
    
    if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
      toast.errorToast(
        `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`
      );
      return;
    }
    let base64: any;

    convertToBase64(file).then((res) => {
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleImageSubmit(type);
    });
  };

  //upload-sign document fucntion ========

  const [signatoryadded, setSignatoryAdded] = useState<any>(false);
  const [extraSignatoryAdded, setExtraSignatoryAdded] = useState(false);
  const [fullAccountCompanyNumber, setFullAccountCompanyNumber] = useState([]);

  const [signatoryId, setSignatoryId] = useState(null);

  const addedSignatory = () => {
    let validateSignatoryPayload = {
      id: signatoryId,
      mandateInstruction: mandate,
      signature: uploadSignature,
      passport: businessSignature,
      scannedID: uploadScannedID,
    };

    

    setUpdating(true);

    axios
      .post(
        `${baseBusinessUrl}CompanySignatoryAccount/CompanySignatoryDocumentUpload`,
        validateSignatoryPayload
      )
      .then((response) => {
        

        if (response.data.isSuccess) {
          setSignatoryAdded(true);
          setSignatory(false);
          setUpdating(false);
          setSignEmailAddress("");
          setSignHouseNumber("");
          setSignStreetName("");
          setSignAreaState("");
          setSignBusStop("");
          setSignAddress("");
          setSignReligion("");
          setSignNationality("");
          setSignIdentityCardType("");
          setSignIdCardName("");
          setSignIssueDate(new Date());
          setSignExpiryDate(new Date());
          setSignReferralCode("");
          setSignIdCardName("");
          setSignCerpacidNumber("");
          setIdCardType("Permanent Voter's Card");
          setMandate("");
          setUploadSignature("");
          setShowUploadSignature(false);
          setBusinessSignature("");
          setShowBusinessSignature(false);
          setUploadScannedID("");
          setShowUploadScannedID(false);
          setSignIdCardNumber("");
        } else {
          setUpdating(false);
          toast.errorToast("Something went wrong!");
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setUpdating(false);
      });
  };

  const addedExtraSignatory = () => {
    let validateSignatoryPayload = {
      id: signatoryId,
      mandateInstruction: mandate,
      signature: uploadSignature,
      passport: businessSignature,
      scannedID: uploadScannedID,
    };

    setUpdating(true);

    axios
      .post(
        `${baseBusinessUrl}CompanySignatoryAccount/CompanySignatoryDocumentUpload`,
        validateSignatoryPayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setExtraSignatoryAdded(true);
          setSignatory(false);
          setUpdating(false);
          setExtraSignatory(false);
          setSignEmailAddress("");
          setSignHouseNumber("");
          setSignStreetName("");
          setSignAreaState("");
          setSignBusStop("");
          setSignAddress("");
          setSignReligion("");
          setSignNationality("");
          setSignIdentityCardType("");
          setSignIdCardName("");
          setSignIssueDate(new Date());
          setSignExpiryDate(new Date());
          setSignReferralCode("");
          setSignIdCardName("");
          setSignCerpacidNumber("");
          setIdCardType("Permanent Voter's Card");
          setSignIdCardNumber("");
          setMandate("");
          setUploadSignature("");
          setShowUploadSignature(false);
          setBusinessSignature("");
          setShowBusinessSignature(false);
          setUploadScannedID("");
          setShowUploadScannedID(false);
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setUpdating(false);
      });
  };

  const completeCompanyDetails = () => {
    let completeBusinessDetailsPayload = {
      tin: tin,
      businessName: businessName,
      businessRegistrationNumber: businessRegistrationNumber,
      streetNumber: streetnumber,
      streetName: streetname,
      nearestBustopLandmark: busStop,
      state: area,
      businessPhoneNumber: businessPhoneNumber,
      dateOfIncorporation: dateOfIncorporation,
      referralCode: referralCode,
      vendorCode: vendorCode,
    };
    setUpdating(true);

    axios
      .post(
        `${baseBusinessUrl}CompanyAccount/CompanyDetails`,
        completeBusinessDetailsPayload
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setComplteSignUpdate(true);
          setUpdateDetailsX(true);
          setUnversalID(response.data.obj.id);
          toast.successToast("Details updated successfully");
          setComplteSignUpdate(true);
          dispatch(setAccountOpeningStep("upload-document"));
          setUpdating(false);
        } else {
          setComplteSignUpdate(true);
          dispatch(setAccountOpeningStep("upload-document"));
          setUpdating(false);
        }
        
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setUpdating(false);
      });
  };

  const signEditFunction = () => {
    setSignatory(true);
  };

  const deleteEditFunction = () => {
    setDeleteSignatoryModal(true);
  };

  const deleteEditExtraFunction = () => {
    setDeleteSignatoryModalExtra(true);
  };

  const maindeleteFunction = () => {
    setSignatoryAdded(false);
    setConfirmDeleteSignatoryModal(true);

    setDeleteSignatoryModal(false);
  };

  const maindeleteFunctionExtra = () => {
    setExtraSignatoryAdded(false);
    setConfirmDeleteSignatoryModalExtra(true);
    setDeleteSignatoryModalExtra(false);
  };

  const [tinError, setTinError] = useState(false);
  const closeTinError = () => {
    setTinError(false);
  };

  // my form data

  const [businessName, setBusinessName] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("");
  const [streetname, setStreetName] = useState("");
  const [streetnumber, setStreetNumber] = useState("");
  const [busStop, setBusStop] = useState("");
  const [area, setArea] = useState("");
  const [businessPhoneNumber, setBusinessPhoneNumber] = useState("");
  const [dateOfIncorporation, setDateOfIncorporation] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [vendorCode, setVendorCode] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [socialMediaType, setSocialMediaType] = useState("");
  const [socialMediaHandle, setSocialMediaHandle] = useState("");
  const handleSocialChange = (event: any) => {
    setSocialMediaType(event.target.value);
  };

  const previousMandateFuntion = () => {
    setBvnNextMandate(false);
    setBvnNextUpdated(true);
  };

  const previousSigantoryBusinessDetails = () => {
    setBvnClose(true);
    setBvnNextUpdated(false);
  };

  const submitNewDocumentUpload = () => {
    // let businessRefereePayload = {
    //   id: universalID,
    //   certificateOfIncorporation: cacDocument,
    //   particularsOfDirectors: co7Document,
    //   shareAllotmentForm: co2Document,
    //   meMart: memartDocument,
    //   cacStatusReport: cac1Document,
    //   applicationForBusinessName: "",
    //   boardResolutionSignedandSealed: businessResolution,
    //   others: othersDocument,
    //   typeOfIndustry: 1,
    //   branchOfDomiciliation: 2,
    //   // currencyOfAccountUSD: "840",
    //   // currencyOfAccountGBP: "826",
    //   // currencyOfAccountNAIRA: "566",
    //   // currencyOfAccountEURO: "978",
    //   currencyOfAccountUSD: "",
    //   currencyOfAccountGBP: "",
    //   currencyOfAccountNAIRA: "",
    //   currencyOfAccountEURO: "",
    //   smsAlertValueAddedService: true,
    //   checkBookValueAddedService: true,
    //   termsCondition: true,
    //   isFlagged: false,
    //   accountTypecode: "210201",
    //   accountTypeName: "Corporate Account",
    //   occupationName: "",
    //   ref1Url: referenceFormUpload,
    //   ref2Url: ""
    // };

    let businessRefereePayload = {
      id: universalID,
      certificateOfIncorporation: "",
      particularsOfDirectors: "",
      shareAllotmentForm: "",
      meMart: "",
      cacStatusReport: "",
      applicationForBusinessName: "",
      boardResolutionSignedandSealed: "",
      others: "",
      typeOfIndustry: parseInt(selectIndustry),
      branchOfDomiciliation: parseInt(branchOfDomiciliation),
      // currencyOfAccountUSD: "840",
      // currencyOfAccountGBP: "826",
      // currencyOfAccountNAIRA: "566",
      // currencyOfAccountEURO: "978",
      currencyOfAccountUSD: "",
      currencyOfAccountGBP: "",
      currencyOfAccountNAIRA: "",
      currencyOfAccountEURO: "",
      smsAlertValueAddedService: true,
      checkBookValueAddedService: true,
      termsCondition: true,
      isFlagged: false,
      accountTypecode: "",
      accountTypeName: "Corporate Account",
      occupationName: "",
      ref1Url: "",
      ref2Url: "",
    };

    if (usd) {
      businessRefereePayload.currencyOfAccountUSD = "840";
    }
    if (gdp) {
      businessRefereePayload.currencyOfAccountGBP = "826";
    }
    if (euro) {
      businessRefereePayload.currencyOfAccountEURO = "978";
    }
    if (ngn) {
      businessRefereePayload.currencyOfAccountNAIRA = "566";
    }
    setUpdating(true);
    
    axios
      .post(
        `${baseBusinessUrl}CompanyAccount/CompanyDocumentUpload`,
        businessRefereePayload
      )
      .then((response) => {
        
        if (
          response?.data?.length > 0 &&
          response?.data[0]?.responseCode == "20"
        ) {
          toast.errorToast(response?.data[0]?.responseMessage);
          setUpdating(false);
          return;
        }
        if (response?.data?.length > 0 && !response?.data[0]?.accountNo) {
          toast.errorToast(response?.data[0]?.responseMessage);
          setUpdating(false);
          return;
        }
        if (response.status === 200) {
          setFullAccountCompanyNumber(response.data);
          setUploadDocumentSuccess(true);
          dispatch(setAccountOpeningStep("new-success-company-account-xxx"));
          
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");
        
        setUpdating(false);
      });
  };

  // this is the document uplaod

  const [combo1, setCombo1] = useState(true);
  const [combo2, setCombo2] = useState(false);
  const [documentAlert, setDocumentAlert] = useState(true);

  const selectCombo1 = () => {
    setCombo1(true);
    setCombo2(false);
  };

  const selectCombo2 = () => {
    setCombo1(false);
    setCombo2(true);
  };
  const [bankBranches, setBankBranches] = useState<IBankBranch[]>([]);
  const [selectIndustry, setSelectIndustry] = useState("");

  const [smsAlert, setSmsAlert] = useState(true);
  const [chequeBook, setChequeBook] = useState(false);
  const [ngn, setNgn] = useState(false);
  const [usd, setUsd] = useState(false);
  const [euro, setEuro] = useState(false);
  const [gdp, setGdp] = useState(false);
  const [termsAndCondition, setTermsAndCondition] = useState(false);
  const [branchOfDomiciliation, setBranchOfDomiciliation] = useState("");

  const handleChangeSelect = (event: any) => {
    setSelectIndustry(event.target.value);
  };
  const handleChangeBranch = (event: any) => {
    setBranchOfDomiciliation(event.target.value);
  };

  const movePrevious = () => {
    dispatch(setAccountOpeningStep("open-add-director"));
  };

  const getBankBranches = () => {
    axios
      .get(`${baseBusinessUrl}Enum/BranchCodeList`)
      .then((response) => {
        setBankBranches(response.data);
      })
      .catch((err) => {
        
      });
  };

  const industries = [
    {
      id: 1,
      name: "Education",
    },
    {
      id: 2,
      name: "Legal and accounting service",
    },
    {
      id: 3,
      name: "Pharmaceuticals",
    },
    {
      id: 4,
      name: "Hospital and clinic",
    },
    {
      id: 5,
      name: "Others",
    },
  ];

  useEffect(() => {
    getBankBranches();
  }, []);

  const [isYesSelected, setIsYesSelected] = useState(false);
  const [isNoSelected, setISNoSelected] = useState(true);
  const [showDocument, setShowDocument] = useState(false);

  const handleIsYesSelected = () => {
    setIsYesSelected(true);
    setISNoSelected(false);
    setShowDocument(true);
  };

  const handleIsNoSelected = () => {
    setIsYesSelected(false);
    setISNoSelected(true);
    setShowDocument(false);
  };

  return (
    <div>
      {documentLoader && <Loader />}
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      {tinError && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Invalid RCN/BRN</h1>
            <p>RCN/BRN was not found, kindly check and retry</p>
            <div className={styles.ErrorButtonFlex}>
              <button className={styles.ErrorCancel} onClick={closeTinError}>
                Cancel
              </button>
              <button className={styles.ErrorRetry} onClick={closeTinError}>
                Retry
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteSignatoryModal && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Delete signatory</h1>
            <p>Are you sure you want to delete this signatory?</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setDeleteSignatoryModal(false)}
              >
                Cancel
              </button>
              <button
                className={styles.ErrorRetry}
                onClick={maindeleteFunction}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteSignatoryModalExtra && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Delete signatory</h1>
            <p>Are you sure you want to delete this signatory?</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setDeleteSignatoryModalExtra(false)}
              >
                Cancel
              </button>
              <button
                className={styles.ErrorRetry}
                onClick={maindeleteFunctionExtra}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmDeleteSignatoryModal && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Signatory deleted</h1>
            <p>The selected signatory has been deleted!</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setConfirmDeleteSignatoryModal(false)}
              >
                okay
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmDeleteSignatoryModalExtra && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Signatory deleted</h1>
            <p>The selected signatory has been deleted!</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setConfirmDeleteSignatoryModalExtra(false)}
              >
                okay
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container-fluid row ">
        <div className={`col-md-5 d-none d-md-inline  ${styles.bg}`}>
          <div className="logo pl-4 pt-5">
            {/* <img src={altLogo} alt="alternative finance logo" onClick="document.location='index.html'" /> */}
            <img src={altBankLogo} alt="alternative finance logo" />
          </div>
          <div className={styles.footer}>
            <p>
              Licensed by Central Bank of Nigeria{" "}
              <img src={cbn} alt="cbn-icon" /> | Powered by{" "}
              <span>The Alternative Bank</span>
            </p>
          </div>
        </div>

        <div className="col-md-7 right_col">
          <div className="d-flex justify-content-end">
            <div className="d-flex flex-column pt-5">
              <div className="d-flex justify-content-end">
                <h1 className="pr-3 mb-4">Company account</h1>
              </div>
              <nav className="mb-4">
                <ol className="breadcrumb bg-white float-right">
                  <li className="breadcrumb-item">
                    {" "}
                    <a href="#">
                      {validated ? (
                        <span>
                          <img className="pr-1" src={Done} alt="" />
                        </span>
                      ) : (
                        <span>
                          <img className="pr-1" src={group1} alt="" />
                        </span>
                      )}
                      <span style={{ marginLeft: "8px" }}>
                        TIN Validation &nbsp;
                      </span>

                      <span>
                        <img src={rightArrow} alt="" />
                      </span>
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    {" "}
                    <a href="#">
                      {completeSignUpdate ? (
                        <span>
                          <img className="pr-1" src={Done} alt="" />
                        </span>
                      ) : (
                        <span>
                          <img className="pr-1" src={no2} alt="" />
                        </span>
                      )}{" "}
                      <span style={{ marginLeft: "8px" }}>
                        Update details &nbsp;
                      </span>
                      <span>
                        <img src={rightArrow} alt="" />
                      </span>
                    </a>
                  </li>

                  <li className="breadcrumb-item">
                    {" "}
                    <a href="#">
                      {uploadDocumentSuccess ? (
                        <span>
                          <img className="pr-1" src={Done} alt="" />
                        </span>
                      ) : (
                        <span>
                          <img className="pr-1" src={no3} alt="" />
                        </span>
                      )}{" "}
                      <span style={{ marginLeft: "8px" }}>Upload document</span>
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-md-11 card validation-card pb-4">
              {accountOpeningStep === "tin-validation" ? (
                <div>
                  <div className="card-form px-4">
                    <div className="card-body">
                      <h4 className="card-title text-center pl-5 mt-4">
                        Validation
                      </h4>
                      <div className="bvn_val mb-4">
                        <img src={Icon_L} alt="" />
                        <small className="sterling-grey-text ml-4">
                          Kindly ensure that your TIN information is up to date
                        </small>
                      </div>
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Existing account number
                          </label>
                        </div>
                        <input
                          className="form-control bvn_input text-muted border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your existing alternative bank account number"
                          value={existingAccountNumber}
                          onChange={(e) => {
                            setExistingAccountNumber(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group" style={{ marginTop: "15px" }}>
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter TIN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          className="form-control bvn_input text-muted border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="RC1234567"
                          value={tin}
                          onChange={(e) => {
                            setTin(e.target.value);
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {validateBtnLoading ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={getSingleTin}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {accountOpeningStep === "otp" && (
                <div>
                  <div className=" card-form pl-5 pr-5 ">
                    <div className="card-body text-center">
                      <h4 className="card-title text-center pt-4 mt-5">
                        Enter OTP
                      </h4>
                      <p className="text-muted">
                        An OTP has been sent to the mobile number and email
                        captured in <br />
                        your BVN. Kindly enter the OTP to proceed.
                      </p>

                      <div style={{ margin: "15px 0" }}>
                        <AuthCode
                          inputClassName={styles.AuthCode}
                          placeholder="*"
                          length={4}
                          allowedCharacters="numeric"
                          onChange={handleOnChange}
                        />
                      </div>

                      {validating ? (
                        <div
                          className="spinner-border text-gold mb-4"
                          role="status"
                        >
                          <span className="sr-only"></span>
                        </div>
                      ) : (
                        <button
                          disabled={otp.length !== 4}
                          type="submit"
                          className="btn btn-danger btn-filled-red mb-4 proceed-btn"
                          onClick={handleVerifyOTP}
                        >
                          Proceed
                        </button>
                      )}

                      <p>
                        {countdownStop?<small>
                          Did not get the OTP?{" "}
                          <span className="font-weight-bold">
                            <u className="cursor-pointer" onClick={reSendOTP}>
                              Resend OTP
                            </u>
                            {/* {!showTimer ? (
                              <u className="cursor-pointer" onClick={reSendOTP}>
                                Resend OTP
                              </u>
                            ) : (
                              <CountdownTimer
                                initialMinutes={3}
                                onComplete={() => setShowTimer(false)}
                              />
                            )} */}
                          </span>
                        </small>:<small>Resend code in {countdownStr}</small>}
                        
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {accountOpeningStep === "open-new-company-account" ? (
                <CompanyDetailsForm
                  signEditFunction={signEditFunction}
                  deleteEditExtraFunction={deleteEditExtraFunction}
                  deleteEditFunction={deleteEditFunction}
                  openSignatory={openSignatory}
                  openExtraSigntory={openExtraSigntory}
                  taxOfficeName={taxOfficeName}
                  completeCompanyDetails={completeCompanyDetails}
                  businessName={businessName}
                  setBusinessName={setBusinessName}
                  businessRegistrationNumber={businessRegistrationNumber}
                  setBusinessRegistrationNumber={setBusinessRegistrationNumber}
                  streetnumber={streetnumber}
                  setStreetNumber={setStreetNumber}
                  streetname={streetname}
                  setStreetName={setStreetName}
                  busStop={busStop}
                  setBusStop={setBusStop}
                  area={area}
                  setArea={setArea}
                  fullAddress={fullAddress}
                  businessPhoneNumber={businessPhoneNumber}
                  setBusinessPhoneNumber={setBusinessPhoneNumber}
                  dateOfIncorporation={dateOfIncorporation}
                  setDateOfIncorporation={setDateOfIncorporation}
                  vendorCode={vendorCode}
                  setVendorCode={setVendorCode}
                  referralCode={referralCode}
                  setReferralCode={setReferralCode}
                  signatoryadded={signatoryadded}
                  updating={updating}
                  extraSignatoryAdded={extraSignatoryAdded}
                  signLastName={signLastName}
                  signMiddleName={signMiddleName}
                  signFirstName={signFirstName}
                  allDirectors={allDirectors}
                  setAllDirectors={setAllDirectors}
                  tin={tin}
                  openDirectorSignatory={openDirectorSignatory}
                  signExtraFirstName={signExtraFirstName}
                  signExtraMiddleName={signExtraMiddleName}
                  signExtraLastName={signExtraLastName}
                  socialMediaType={socialMediaType}
                  socialMediaHandle={socialMediaHandle}
                  handleSocialChange={handleSocialChange}
                  setSocialMediaHandle={setSocialMediaHandle}
                />
              ) : (
                ""
              )}
              {accountOpeningStep === "open-add-director" ? (
                <AddDirectors
                  openSignatory={openDirectorSignatory}
                  newDirectorAddded={newDirectorAddded}
                  previousNewDirectorAdded={previousNewDirectorAdded}
                  allDirectors={allDirectors}
                  setAllDirectors={setAllDirectors}
                  tin={tin}
                />
              ) : (
                ""
              )}
              {accountOpeningStep === "upload-document" && (
                <div>
                  {documentAlert && (
                    <div className={styles.ErrorBg}>
                      <div className={styles.ErrorContain}>
                        <h1>Select document upload combo</h1>
                        <p>
                          Select the document combination based on your company
                          registration documents
                        </p>
                        <div className={styles.ErrorButtonFlex}>
                          <button
                            className={styles.ErrorCancel}
                            onClick={() => {
                              setDocumentAlert(false);
                            }}
                          >
                            Okay
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className=" card-form pl-1 pr-1 ">
                    <div className="card-body">
                      <h4 className="card-title text-center pl-3 mt-5">
                        Upload documents
                      </h4>
                      <p className="text-center">
                        <small>Select Document upload combo</small>
                      </p>
                      <div className={styles.selector}>
                        <div className={styles.firstSelector}>
                          <img src={Icon_L} alt="" />
                          <p>Do you have any pending documents to upload?</p>
                        </div>
                        <div className={styles.secondSelector}>
                          <p
                            className={
                              isYesSelected ? `${styles.selected}` : ``
                            }
                            onClick={handleIsYesSelected}
                          >
                            Yes
                          </p>
                          <p
                            className={isNoSelected ? `${styles.selected}` : ``}
                            onClick={handleIsNoSelected}
                          >
                            No
                          </p>
                        </div>
                      </div>
                      <br />
                      {showDocument && (
                        <>
                          <div className={styles.comboHeader}>
                            <div
                              className={
                                combo1 ? styles.selected : styles.comboContainer
                              }
                              onClick={selectCombo1}
                            >
                              <div className={styles.comboTextNumber}>
                                Combo 1
                              </div>
                              <div className={styles.comboText}>
                                CAC, CO2, CO7, MEMART, Board Resolution (signed
                                and sealed), References and Others
                              </div>
                            </div>
                            <div
                              className={
                                combo2 ? styles.selected : styles.comboContainer
                              }
                              onClick={selectCombo2}
                            >
                              <div className={styles.comboTextNumber}>
                                Combo 2
                              </div>
                              <div className={styles.comboText}>
                                CAC, CAC1.1/Status report, MEMART, Board
                                Resolution (signed and sealed), References and
                                Others
                              </div>
                            </div>
                          </div>
                          <br />
                          <p className="text-center">
                            <small>
                              Upload pdf file formats, Asteriked items (
                              <sup style={{ color: "red" }}>**</sup>) are
                              mandatory
                            </small>
                          </p>
                          {combo1 ? (
                            <>
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        CAC(Certificate of Incorporation)
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showCacDocument ? (
                                          <p className="label_text">
                                            Certificate Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click or drag <br /> and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "cac")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>

                                <div className="col-xl-6">
                                  <div className="col-lg-12 ml-n3">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        CO2 (Share Allotment Form)
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showCo2Document ? (
                                          <p className="label_text">
                                            Document Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "co2")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        CO7(Particulars of Directors)
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showCo7Document ? (
                                          <p className="label_text">
                                            Document Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click or drag <br /> and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "co7")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>

                                <div className="col-xl-6">
                                  <div className="col-lg-12 ml-n3">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        MEMART (memorandum and articles of{" "}
                                        <br /> association)
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showMemartDocument ? (
                                          <p className="label_text">
                                            Document Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "memert")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label
                                      htmlFor="firstname"
                                      className="label_text2 text-nowrap font-weight-bold"
                                    >
                                      <b>
                                        Board resolution signed and sealed
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showBusinessResolution ? (
                                          <p className="label_text">
                                            Document uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(
                                            e,
                                            "businessResolution"
                                          )
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="col-lg-12 ml-n3">
                                    <label
                                      htmlFor="firstname"
                                      className="label_text2 text-nowrap font-weight-bold"
                                    >
                                      <b>
                                        {" "}
                                        Upload reference form
                                        {/* <sup style={{color: "red"}}>
                                    <b>**</b>
                                  </sup> */}
                                      </b>
                                    </label>
                                    <label
                                      className="cursor-pointer"
                                      htmlFor="BusinessName"
                                    >
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showReferenceFormUpload ? (
                                          <p className="label_text">
                                            Reference Form Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(
                                            e,
                                            "referenceFormRealUpload"
                                          )
                                        }
                                        id="BusinessName"
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>Others</b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showOthersDocument ? (
                                          <p className="label_text">
                                            Document uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "othersDocument")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="col-lg-12 ml-n3">
                                    <label
                                      htmlFor="firstname"
                                      className="label_text2 text-nowrap font-weight-bold"
                                    >
                                      <b>
                                        {" "}
                                        Download Reference form
                                        {/* <sup style={{color: "red"}}>
                                    <b>**</b>
                                  </sup> */}
                                      </b>
                                    </label>
                                    <label
                                      className="cursor-pointer"
                                      htmlFor="BusinessName"
                                    >
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        <a
                                          href={referenceFormPdf}
                                          download="Reference Form"
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <p className="label_text">
                                            Click to Download Reference form
                                          </p>
                                        </a>
                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(
                                            e,
                                            "applicationForBusinessName"
                                          )
                                        }
                                        id="BusinessName"
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label
                                      htmlFor="firstname"
                                      className="label_text2 text-nowrap font-weight-bold"
                                    >
                                      <b>
                                        {" "}
                                        Utility Bill
                                        <sup>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label
                                      className="cursor-pointer"
                                      htmlFor="parentofUtilitybill"
                                    >
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showUtilityBill ? (
                                          <p className="label_text">
                                            Utility Bill Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click or drag <br /> and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>

                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "utilityBill")
                                        }
                                        id="parentofUtilitybill"
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        CAC(Certificate of Incorporation)
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showCacDocument ? (
                                          <p className="label_text">
                                            Certificate Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click or drag <br /> and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "cac")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>

                                <div className="col-xl-6">
                                  <div className="col-lg-12 ml-n3">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        CAC1.1/Status report
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label
                                      className="cursor-pointer"
                                      htmlFor="BusinessName"
                                    >
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showCac1Document ? (
                                          <p className="label_text">
                                            Document Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "cac1")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: "10px" }}
                              >
                                <div className="col-xl-6">
                                  <div className="col-lg-12 ml-n3">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>
                                        {" "}
                                        MEMART (memorandum and articles of{" "}
                                        <br /> association)
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showMemartDocument ? (
                                          <p className="label_text">
                                            Document Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "memert")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label
                                      htmlFor="firstname"
                                      className="label_text2 text-nowrap font-weight-bold"
                                    >
                                      <b>
                                        Board resolution signed and sealed
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showBusinessResolution ? (
                                          <p className="label_text">
                                            Document uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(
                                            e,
                                            "businessResolution"
                                          )
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label className="label_text2 text-nowrap font-weight-bold">
                                      <b>Others</b>
                                    </label>
                                    <label className="cursor-pointer">
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showOthersDocument ? (
                                          <p className="label_text">
                                            Document uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click to upload or drag
                                            <br />
                                            and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>
                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "othersDocument")
                                        }
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-6"></div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <div className="col-md-6">
                                    <label
                                      htmlFor="firstname"
                                      className="label_text2 text-nowrap font-weight-bold"
                                    >
                                      <b>
                                        {" "}
                                        Utility Bill
                                        <sup>
                                          <b>**</b>
                                        </sup>
                                      </b>
                                    </label>
                                    <label
                                      className="cursor-pointer"
                                      htmlFor="parentofUtilitybill"
                                    >
                                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                        {showUtilityBill ? (
                                          <p className="label_text">
                                            Utility Bill Uploaded
                                          </p>
                                        ) : (
                                          <p className="label_text">
                                            Click or drag <br /> and drop file
                                          </p>
                                        )}

                                        <img
                                          className="img-fluid"
                                          src={uploadArrow}
                                          alt=""
                                        />
                                      </div>

                                      <input
                                        onChange={(e) =>
                                          handleFileUpload(e, "utilityBill")
                                        }
                                        id="parentofUtilitybill"
                                        className="input-file-type"
                                        type="file"
                                        name="file"
                                        accept="image/png, image/jpg, image/jpeg"
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}

                      <br />
                      <div>
                        <label
                          htmlFor="branch domicilation"
                          className="label_text"
                        >
                          Select type of sector/industry
                        </label>
                        <select
                          name="typeOfIndustry"
                          value={selectIndustry}
                          onChange={handleChangeSelect}
                          className="form-control border-dark  bg-white py-2"
                          id=""
                        >
                          <option value="">
                            Select type of sector/industry
                          </option>
                          {industries.map((industry: IIndustry) => {
                            return (
                              <option key={industry.id} value={industry.id}>
                                {industry.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {/* {selectIndustry.length !== 0 && (
                        <div className="row">
                          <div className="col-md-6 mt-2">
                            <div className="col-md-6">
                              <label
                                htmlFor="firstname"
                                className="label_text2 text-nowrap font-weight-bold"
                              >
                                <b>
                                  {selectIndustry === "1" &&
                                    `State government approval/National UNI commission approval`}
                                  {selectIndustry === "2" &&
                                    `upload Evidence of membership to professional body (Call to bar cert, CITN, ICAN etc.)`}
                                  {selectIndustry === "3" &&
                                    `Annual license to practice.)`}
                                  {selectIndustry === "4" &&
                                    `Annual license to practice.)`}

                                  <sup style={{color: "red"}}>
                                    <b>**</b>
                                  </sup>
                                </b>
                              </label>
                              <label className="cursor-pointer">
                                <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                  {showExtraDocument ? (
                                    <p className="label_text">
                                      Document uploaded
                                    </p>
                                  ) : (
                                    <p className="label_text">
                                      Click to upload or drag
                                      <br />
                                      and drop file
                                    </p>
                                  )}

                                  <img
                                    className="img-fluid"
                                    src={uploadArrow}
                                    alt=""
                                  />
                                </div>
                                <input
                                  onChange={(e) =>
                                    handleFileUpload(e, "extraDocument")
                                  }
                                  className="input-file-type"
                                  type="file"
                                  name="file"
                                  accept="image/png, image/jpg, image/jpeg"
                                />
                              </label>
                            </div>
                          </div>
                          <div className="col-xl-6"></div>
                        </div>
                      )} */}
                      <br />
                      <div>
                        <label
                          htmlFor="branch domicilation"
                          className="label_text"
                        >
                          Branch of account domiciliation
                        </label>
                        <select
                          name="branchOfDomiciliation"
                          value={branchOfDomiciliation}
                          onChange={handleChangeBranch}
                          className="form-control border-dark  bg-white py-2"
                          id=""
                        >
                          <option value="">
                            Select branch of account domiciliation
                          </option>
                          {bankBranches.map((branch: IBankBranch) => {
                            return (
                              <option
                                key={branch.brancH_CODE}
                                value={branch.brancH_CODE}
                              >
                                {branch.branch}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className={styles.rowSms}>
                        <div
                          className="col-md-4 form-group"
                          style={{ display: "flex", width: "80%" }}
                        >
                          <div className="custom-control custom-checkbox input-group mb-2">
                            <input
                              name="smsAlertValueAddedService"
                              checked={smsAlert}
                              onChange={(e) => setSmsAlert(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox1"
                            />
                            <label
                              className="custom-control-label pl-3"
                              htmlFor="checkbox1"
                            >
                              SMS/ Email alert
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                            {/* <input type="checkbox" className="custom-control-input" id="checkbox" onclick="ShowHideDiv(this)"> */}
                            <input
                              name="debitCardValueAddedService"
                              checked={chequeBook}
                              onChange={(e) => setChequeBook(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox"
                            />
                            <label
                              className="custom-control-label pl-3 text-nowrap"
                              htmlFor="checkbox"
                            >
                              Cheque book
                            </label>
                          </div>
                        </div>
                      </div>
                      <br />
                      <div
                        // className="row container"
                        style={{ display: "flex", width: "80%" }}
                      >
                        <div className="col-md-4 form-group">
                          <div className="">
                            <input
                              name="smsAlertValueAddedService"
                              checked={ngn}
                              onChange={(e) => setNgn(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox1"
                            />
                            <label className="" htmlFor="checkbox1">
                              NGN
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 form-group">
                          <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                            <input
                              name="emailAlertValueAddedService"
                              checked={usd}
                              onChange={(e) => setUsd(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox3"
                            />
                            <label
                              className="custom-control-label pl-3"
                              htmlFor="checkbox3"
                            >
                              USD
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 form-group">
                          <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                            <input
                              name="emailAlertValueAddedService"
                              checked={euro}
                              onChange={(e) => setEuro(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox3"
                            />
                            <label
                              className="custom-control-label pl-3"
                              htmlFor="checkbox3"
                            >
                              EURO
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 form-group">
                          <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox4"
                              checked={gdp}
                              onChange={(e) => setGdp(e.target.checked)}
                            />
                            <label
                              className="custom-control-label pl-3 text-nowrap"
                              htmlFor="checkbox4"
                            >
                              GDP
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row container mt-3 ml-1">
                        <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="checkbox4"
                            checked={termsAndCondition}
                            onChange={(e) =>
                              setTermsAndCondition(e.target.checked)
                            }
                          />
                          <label
                            className="custom-control-label pl-3"
                            htmlFor="checkbox4"
                          >
                            By checking this box, you have accepted the{" "}
                            <span>
                              <a
                                href={termsAndConditionPdf}
                                download="tac"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>Terms and conditions</u>
                              </a>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-2">
                      <div
                        className="mb-3 mr-4"
                        style={{ marginRight: "20px" }}
                      >
                        <button
                          className="btn btn-outline-gold mr-3 btn-filled-white"
                          onClick={movePrevious}
                        >
                          Previous
                        </button>
                      </div>
                      {!termsAndCondition || !smsAlert ? (
                        <button className={styles.submit}>Proceed</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={submitNewDocumentUpload}
                            >
                              Proceed
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {accountOpeningStep === "new-success-company-account-xxx" && (
                <div>
                  <div className="card-body text-center">
                    <SuccessIcon/>
                    <h4 className="card-title text-center pl-3 mt-5">
                      Congratulations {accountName}, your <br /> account opening
                      was successful
                    </h4>
                    <p className="text-center text-muted">
                      Here is your account number
                    </p>
                    {fullAccountCompanyNumber.map((acc: any) => {
                      return (
                        <>
                          {acc?.accountNo?.length > 1 && (
                            <div className={styles.sucessFlexHolder}>
                              <div className={styles.successCurrency}>
                                {acc.currency}
                              </div>
                              <p className={styles.successAccountNumber}>
                                {acc.accountNo}
                              </p>
                              <img
                                className="img-fluid pb-2"
                                src={copyButton}
                                alt=""
                                onClick={() =>
                                  copyAccountNumberToClipboard(acc.accountNo)
                                }
                              />
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>

                  {/* <div className=" row text-center">
                    <div className="col-md-12">
                     
                    </div>
                  </div> */}
                  <div className={styles.flexFamily}>
                    <button
                      className="btn btn-outline-gold mr-3 btn-filled-white"
                      onClick={navigateHome}
                    >
                      Okay
                    </button>
                    {/* <button
                      type="submit"
                      className="btn btn-danger btn-filled-red"
                      onClick={addreference}
                    >
                      Add Reference
                    </button> */}
                  </div>
                </div>
              )}
              {accountOpeningStep === "add-reference" && (
                <NewAddReference universalID={universalID} />
              )}
            </div>
          </div>
        </div>
      </div>
      {signatory && (
        <div>
          <div className={styles.signatoryBg}>
            <div className={styles.signatoryContainer}>
              <div>
                <div className={styles.signHeader}>
                  <div className={styles.signFirst}>
                    <img
                      src={backArrow}
                      alt=""
                      onClick={() => setSignatory(false)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.signSecond}>
                    <h4>{isDirectorOpen ? `Add director` : `Add Signatory`}</h4>
                    {!isDirectorOpen && (
                      <nav className="mb-4">
                        <ol className="breadcrumb bg-white float-right">
                          <li className="breadcrumb-item">
                            {" "}
                            <a href="#"></a>
                          </li>
                          <li className="breadcrumb-item">
                            {" "}
                            <a href="#">
                              {bvnUpdateValidated ? (
                                <span>
                                  <img className="pr-1" src={Done} alt="" />
                                </span>
                              ) : (
                                <span>
                                  <img className="pr-1" src={group1} alt="" />
                                </span>
                              )}
                              Update details &nbsp;
                              <span>
                                <img src={rightArrow} alt="" />
                              </span>
                            </a>
                          </li>
                          <li className="breadcrumb-item">
                            {" "}
                            <a href="#">
                              <span>
                                <img className="pr-1" src={no2} alt="" />
                              </span>{" "}
                              Mandates and documents
                            </a>
                          </li>
                        </ol>
                      </nav>
                    )}
                  </div>
                </div>
                {bvnClose && (
                  <div className="card-form px-4">
                    {/* <Toaster position="top-center" reverseOrder={false} /> */}
                    <div className="card-body">
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter BVN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          name="bvn"
                          value={inputs.bvn}
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={11}
                          className="form-control bvn_input border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your BVN"
                        />
                      </div>

                      <div className="mt-4">
                        <label htmlFor="gender" className="fila">
                          Date of birth
                        </label>
                        <div className="form-group d-flex">
                          <select
                            name="day"
                            value={inputs.day}
                            onChange={handleChange}
                            className="form-control bvn_inpu border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Day</option>
                            {days.map((day) => {
                              return (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="month"
                            value={inputs.month}
                            onChange={handleChange}
                            className="form-control bvn_input border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Month</option>
                            {months.map((month) => {
                              return (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="year"
                            value={inputs.year}
                            onChange={handleChange}
                            className="form-control bvn_input border-dark"
                          >
                            <option>Year</option>
                            {years.map((year) => {
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {bvnValidating ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={handleValidateBVN}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {bvnNextUpdated && (
                  <div>
                    <div className="bvn_val mb-4" id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="text-danger ml-4 font-weight-bold">
                        <b>
                          {isDirectorOpen
                            ? `Update the director’s address and email if  it has changed`
                            : ` Update your address and email if it has changed`}
                        </b>
                      </small>
                    </div>
                    <div>
                      <div className=" card-form pl- pr-">
                        <div className={styles.formflex}>
                          <div className={styles.form}>
                            <label className="label_text">
                              Firstname{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              name="firstName"
                              value={signFirstName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">
                              Secondname{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              name="secondName"
                              value={signMiddleName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">
                              Lastname{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              name="lastName"
                              value={signLastName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    Phone number{" "}
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </label>
                                  <input
                                    name="phoneNumber"
                                    onChange={(e) => {
                                      setSignPhoneNumber(e.target.value);
                                    }}
                                    value={signPhoneNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter Phone number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Date of birth{" "}
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </label>
                                  <input
                                    value={`${inputs.month}-${inputs.day}-${inputs.year}`}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Email address
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              name="emailAddress"
                              onChange={(e) => {
                                setSignEmailAddress(e.target.value);
                              }}
                              value={signEmailAddress}
                              type="email"
                              className="form-control bg-white border-dark"
                              placeholder="eg johndoe@gmail.com"
                            />
                          </div>

                          <div className="row"></div>
                          <label
                            htmlFor="residentialaddress"
                            className="label_text my-2 font-weight-bold"
                          >
                            <b>
                              Residential address{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </b>
                          </label>

                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    House number
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignHouseNumber(e.target.value)
                                    }
                                    value={signHouseNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter house number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Street name{" "}
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignStreetName(e.target.value)
                                    }
                                    value={signStreetName}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter street name"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Area/State{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter Area/State"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Nearest bus-top/landmark{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              onChange={(e) => setSignBusStop(e.target.value)}
                              value={signBusStop}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter nearest landmark"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Address{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              value={`${signHouseNumber}, ${signStreetName} ${signBusStop} ${signAreaState}`}
                              className="form-control sec border-dark"
                              type="text"
                              placeholder="Enter full address"
                            />
                          </div>

                          {!isDirectorOpen && (
                            <div className="row mt-3 mb-4">
                              <div className="col form-group">
                                <label
                                  htmlFor="religion"
                                  className="label_text"
                                >
                                  Religion{" "}
                                  <sup style={{ color: "red" }}>
                                    <b>**</b>
                                  </sup>
                                </label>
                                <select
                                  onChange={(e) =>
                                    setSignReligion(e.target.value)
                                  }
                                  value={signReligion}
                                  className="form-control border-dark"
                                >
                                  {getReligion.map((religion: IReligion) => {
                                    return (
                                      <option
                                        key={religion.id}
                                        value={religion.id}
                                      >
                                        {religion.religion}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          )}

                          <div className=" row form-group d-flex mb-4">
                            <div className="row">
                              <div className="col sec">
                                <div className="row form-row mb-3">
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="employment"
                                      className="label_text"
                                    >
                                      Select Nationality{" "}
                                      <sup style={{ color: "red" }}>
                                        <b>**</b>
                                      </sup>
                                    </label>
                                    <select
                                      name="selfEmploymentInformation"
                                      onChange={(e) =>
                                        setSignNationality(e.target.value)
                                      }
                                      value={signNationality}
                                      className="form-control border-dark bg-white"
                                      // placeholder="select Nationality"
                                    >
                                      <option value="" disabled hidden>select Nationality</option>
                                      {nationalityData.map((data) => {
                                        return (
                                          <option key={data.id} value={data.id}>
                                            {data.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="cerpacidNumber"
                                      className="label_text"
                                      style={{ fontSize: "0.6rem" }}
                                    >
                                      CERPAC ID number (If nationality is
                                      notNigerian)
                                    </label>
                                    <input
                                      name="cerpacidNumber"
                                      onChange={(e) =>
                                        setSignCerpacidNumber(e.target.value)
                                      }
                                      value={signCerpacidNumber}
                                      type="text"
                                      className="form-control bg-white border-dark"
                                      placeholder="eg 1234567890123"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            {/* <label className="label_text">
                              Select identity card type
                            </label>

                            <ul
                              className="nav nav-pills identity-tab mb-3 nav-fill"
                              id="pills-tab"
                              role="tablist"
                            >
                              {meansOfIdentification.map(
                                (identification: IMeansOfIdentification) => {
                                  return (
                                    <li
                                      className="nav-item"
                                      key={identification.id}
                                      onClick={() =>
                                        handleSetIdCardType(identification.text)
                                      }
                                    >
                                      <a
                                        className={`nav-link text-nowrap pl-0 pt-2 ${identification.id === 1
                                          ? "active"
                                          : ""
                                          }`}
                                        id="pills-int-tab"
                                        data-toggle="pill"
                                        href="#pills-int"
                                        role="tab"
                                        aria-controls="pills-int"
                                        aria-selected="true"
                                      >
                                        {identification.text}
                                      </a>
                                    </li>
                                  );
                                }
                              )}
                            </ul> */}
                            <div className="tab-content" id="pills-tabContent">
                              <div
                                className="tab-pane show fade active"
                                id="1"
                                role="tabpanel"
                                aria-labelledby="pills-int-tab"
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="label_text">
                                        ID card number{" "}
                                        <sup style={{ color: "red" }}>
                                          <b>**</b>
                                        </sup>
                                      </label>
                                      <input
                                        name="idCardNumber"
                                        onChange={(e) =>
                                          setSignIdCardNumber(e.target.value)
                                        }
                                        value={signIdCardNumber}
                                        className="form-control border-dark"
                                        type="text"
                                        placeholder="Enter ID card number"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group identity">
                                      <label
                                        htmlFor="issuedate"
                                        className="label_text"
                                      >
                                        Issue Date
                                      </label>
                                      <DatePickerComponent
                                        value={signIssueDate}
                                        setDate={setSignIssueDate}
                                        issueYear
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="label_text">
                                        Expiry Date
                                      </label>

                                      <DatePickerComponent
                                        value={signExpiryDate}
                                        setDate={setSignExpiryDate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group mt-4 mb-4">
                            <label className="label_text">
                              ID Card name{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              className="form-control border-dark"
                              type="text"
                              value={signIdCardName}
                              onChange={(e) =>
                                setSignIdCardName(e.target.value)
                              }
                              placeholder="Enter ID Card Name"
                            />
                          </div>

                          <div className="d-flex justify-content-end mt-4">
                            <button
                              style={{ marginRight: "10px" }}
                              className="btn btn-outline-goldr-3 btn-filled-white"
                              onClick={previousSigantoryBusinessDetails}
                            >
                              Previous
                            </button>
                            {businessSignatoryDetailsLoading ? (
                              <div
                                className="spinner-border text-gold"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-danger btn-filled-red"
                                onClick={businessSignatoryDetails}
                              >
                                Proceed
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {bvnNextMandate && (
                  <div>
                    <div className={styles.signDoubleHeader}>
                      <label htmlFor="">Mandate instruction</label>
                      <br />
                      <textarea
                        placeholder="Enter mandate instruction"
                        value={mandate}
                        onChange={(e) => setMandate(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Signature
                          </label>
                          <label
                            className="cursor-pointer"
                            htmlFor="parentofCertificateOfResgistration"
                          >
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}

                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "signature")}
                              id="parentofCertificateOfResgistration"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="col-lg-12 ml-n3">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload passport
                          </label>
                          <label className="cursor-pointer">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showBusinessSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) =>
                                handleFileUpload(e, "BusinessName")
                              }
                              id="BusinessName"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Scanned ID
                          </label>
                          <label className="cursor-pointer" htmlFor="parentof">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadScannedID ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "scannedID")}
                              id="parentof"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        style={{ marginRight: "10px" }}
                        className="btn btn-outline-gold mr-3 btn-filled-white"
                        onClick={previousMandateFuntion}
                      >
                        Previous
                      </button>
                      {mandate?.length < 1 ||
                      !showBusinessSignature ||
                      !showUploadScannedID ||
                      !showUploadSignature ? (
                        <button className={styles.submit}>Add signatory</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={addedSignatory}
                            >
                              Add signatory
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {addDirector && (
        <div>
          <div className={styles.signatoryDirectorBg}>
            <div className={styles.signatoryDirectorContainer}>
              <div>
                <div className={styles.signHeader}>
                  <div className={styles.signFirst}>
                    <img
                      src={backArrow}
                      alt=""
                      onClick={closeDirectorSignatory}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.signDirectoySecond}>
                    <h4>{isDirectorOpen ? `Add director` : `Add Signatory`}</h4>
                  </div>
                </div>
                {bvnClose && (
                  <div className="card-form px-4">
                    {/* <Toaster position="top-center" reverseOrder={false} /> */}
                    <div className="card-body">
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter director’s BVN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          name="bvn"
                          value={directorInputs.bvn}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={handleDirectorChange}
                          maxLength={11}
                          className="form-control bvn_input border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your BVN"
                        />
                      </div>

                      <div className="mt-4">
                        <label htmlFor="gender" className="fila">
                          Director date of birth
                        </label>
                        <div className="form-group d-flex">
                          <select
                            name="day"
                            value={directorInputs.day}
                            onChange={handleDirectorChange}
                            className="form-control bvn_inpu border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Day</option>
                            {days.map((day) => {
                              return (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="month"
                            value={directorInputs.month}
                            onChange={handleDirectorChange}
                            className="form-control bvn_input border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Month</option>
                            {months.map((month) => {
                              return (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="year"
                            value={directorInputs.year}
                            onChange={handleDirectorChange}
                            className="form-control bvn_input border-dark"
                          >
                            <option>Year</option>
                            {years.map((year) => {
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {bvnValidating ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={validateDirectorBVN}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {bvnNextUpdated && (
                  <div>
                    <div className="bvn_val mb-4" id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="text-danger ml-4 font-weight-bold">
                        <b>
                          {isDirectorOpen
                            ? `Update the director’s address and email if  it has changed`
                            : ` Update your address and email if it has changed`}
                        </b>
                      </small>
                    </div>
                    <div>
                      <div className=" card-form pl- pr-">
                        <div className={styles.formflex}>
                          <div className={styles.form}>
                            <label className="label_text">Firstname</label>
                            <input
                              name="firstName"
                              value={directorFirstName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">Secondname</label>
                            <input
                              name="secondName"
                              value={directorMiddleName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">Lastname</label>
                            <input
                              name="lastName"
                              value={directorLastName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    Phone number
                                  </label>
                                  <input
                                    name="phoneNumber"
                                    onChange={(e) => {
                                      setDirectorPhoneNumber(e.target.value);
                                    }}
                                    value={directorPhoneNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter Phone number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Date of birth
                                  </label>
                                  <input
                                    value={`${directorInputs.month}-${directorInputs.day}-${directorInputs.year}`}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">Email address</label>
                            <input
                              name="emailAddress"
                              onChange={(e) => {
                                setDirectorEmail(e.target.value);
                              }}
                              value={directorEmail}
                              type="email"
                              className="form-control bg-white border-dark"
                              placeholder="Enter email address"
                            />
                          </div>

                          <div className="row"></div>
                          <label
                            htmlFor="residentialaddress"
                            className="label_text my-2 font-weight-bold"
                          >
                            <b>Residential address</b>
                          </label>

                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    House number
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignHouseNumber(e.target.value)
                                    }
                                    value={signHouseNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter house number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Street name
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignStreetName(e.target.value)
                                    }
                                    value={signStreetName}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter street name"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">Area/State</label>
                            <input
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter Area/State"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Nearest bus-top/landmark
                            </label>
                            <input
                              onChange={(e) => setSignBusStop(e.target.value)}
                              value={signBusStop}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter nearest landmark"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">Address</label>
                            <input
                              value={`${signHouseNumber}, ${signStreetName} ${signBusStop} ${signAreaState}`}
                              className="form-control sec border-dark"
                              type="text"
                              placeholder="Enter full address"
                            />
                          </div>

                          <div className=" row form-group d-flex mb-4">
                            <div className="row">
                              <div className="col sec">
                                <div className="row form-row mb-3">
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="employment"
                                      className="label_text"
                                    >
                                      Select Nationality
                                    </label>
                                    <select
                                      name="selfEmploymentInformation"
                                      onChange={(e) =>
                                        setSignNationality(e.target.value)
                                      }
                                      value={signNationality}
                                      className="form-control border-dark bg-white"
                                      // placeholder="select Nationality"
                                    >
                                      <option value="" disabled hidden>select Nationality</option>
                                      {nationalityData.map((data) => {
                                        return (
                                          <option key={data.id} value={data.id}>
                                            {data.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="cerpacidNumber"
                                      className="label_text"
                                      style={{ fontSize: "0.6rem" }}
                                    >
                                      CERPAC ID number (If nationality is
                                      notNigerian)
                                    </label>
                                    <input
                                      name="cerpacidNumber"
                                      onChange={(e) =>
                                        setSignCerpacidNumber(e.target.value)
                                      }
                                      value={signCerpacidNumber}
                                      type="text"
                                      className="form-control bg-white border-dark"
                                      placeholder="eg 1234567890123"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex justify-content-end mt-4">
                            <button
                              style={{ marginRight: "10px" }}
                              className="btn btn-outline-gold mr-3 btn-filled-white"
                              onClick={previousSigantoryBusinessDetails}
                            >
                              Previous
                            </button>
                            {businessSignatoryDetailsLoading ? (
                              <div
                                className="spinner-border text-gold"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-danger btn-filled-red"
                                onClick={addNewDirector}
                              >
                                Add Director
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {extraSignatory && (
        <div>
          <div className={styles.signatoryBg}>
            <div className={styles.signatoryContainer}>
              <div>
                <div className={styles.signHeader}>
                  <div className={styles.signFirst}>
                    <img
                      src={backArrow}
                      alt=""
                      onClick={() => setExtraSignatory(false)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.signSecond}>
                    <h4>Add Signatory</h4>
                    <nav className="mb-4">
                      <ol className="breadcrumb bg-white float-right">
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            {/* {validated ? (
                              <span>
                                <img className="pr-1" src={Done} alt="" />
                              </span>
                            ) : (
                              <span>
                                <img className="pr-1" src={group1} alt="" />
                              </span>
                            )} */}
                            {/* Bvn Validation &nbsp;
                            <span>
                              <img src={rightArrow} alt="" />
                            </span> */}
                          </a>
                        </li>
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            {bvnUpdateValidated ? (
                              <span>
                                <img className="pr-1" src={Done} alt="" />
                              </span>
                            ) : (
                              <span>
                                <img className="pr-1" src={group1} alt="" />
                              </span>
                            )}
                            Update details &nbsp;
                            <span>
                              <img src={rightArrow} alt="" />
                            </span>
                          </a>
                        </li>
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            <span>
                              <img className="pr-1" src={no2} alt="" />
                            </span>{" "}
                            Mandates and documents
                          </a>
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                {bvnClose && (
                  <div className="card-form px-4">
                    {/* <Toaster position="top-center" reverseOrder={false} /> */}
                    <div className="card-body">
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter BVN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          name="bvn"
                          value={extraInputs.bvn}
                          onChange={handleExtraChange}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={11}
                          className="form-control bvn_input border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your BVN"
                        />
                      </div>

                      <div className="mt-4">
                        <label htmlFor="gender" className="fila">
                          Date of birth
                        </label>
                        <div className="form-group d-flex">
                          <select
                            name="day"
                            value={extraInputs.day}
                            onChange={handleExtraChange}
                            className="form-control bvn_inpu border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Day</option>
                            {days.map((day) => {
                              return (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="month"
                            value={extraInputs.month}
                            onChange={handleExtraChange}
                            className="form-control bvn_input border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Month</option>
                            {months.map((month) => {
                              return (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="year"
                            value={extraInputs.year}
                            onChange={handleExtraChange}
                            className="form-control bvn_input border-dark"
                          >
                            <option>Year</option>
                            {years.map((year) => {
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {bvnValidating ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={validateExtraBVN}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {bvnNextUpdated && (
                  <div>
                    <div className="bvn_val mb-4" id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="text-danger ml-4 font-weight-bold">
                        {isDirectorOpen
                          ? `Update the director’s address and email if  it has changed`
                          : ` Update your address and email if it has changed`}
                      </small>
                    </div>
                    <div>
                      <div className=" card-form pl- pr-">
                        <div className={styles.formflex}>
                          <div className={styles.form}>
                            <label className="label_text">Firstname</label>
                            <input
                              name="firstName"
                              value={signExtraFirstName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">Secondname</label>
                            <input
                              name="secondName"
                              value={signExtraMiddleName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">Lastname</label>
                            <input
                              name="lastName"
                              value={signExtraLastName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    Phone number
                                  </label>
                                  <input
                                    name="phoneNumber"
                                    value={signExtraPhoneNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter Phone number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Date of birth
                                  </label>
                                  <input
                                    value={`${extraInputs.month}-${extraInputs.day}-${extraInputs.year}`}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">Email address</label>
                            <input
                              name="emailAddress"
                              onChange={(e) => {
                                setSignEmailAddress(e.target.value);
                              }}
                              value={signEmailAddress}
                              type="email"
                              className="form-control bg-white border-dark"
                              placeholder="Enter email address"
                            />
                          </div>

                          <div className="row"></div>
                          <label
                            htmlFor="residentialaddress"
                            className="label_text my-2 font-weight-bold"
                          >
                            <b>Residential address</b>
                          </label>

                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    House number
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignHouseNumber(e.target.value)
                                    }
                                    value={signHouseNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter house number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Street name
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignStreetName(e.target.value)
                                    }
                                    value={signStreetName}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter street name"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">Area/State</label>
                            <input
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter Area/State"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Nearest bus-top/landmark
                            </label>
                            <input
                              onChange={(e) => setSignBusStop(e.target.value)}
                              value={signBusStop}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter nearest landmark"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">Address</label>
                            <input
                              value={`${signHouseNumber}, ${signStreetName} ${signBusStop} ${signAreaState}`}
                              className="form-control sec border-dark"
                              type="text"
                              placeholder="Enter full address"
                            />
                          </div>

                          <div className="row mt-3 mb-4">
                            <div className="col form-group">
                              <label htmlFor="religion" className="label_text">
                                Religion
                              </label>
                              <select
                                onChange={(e) =>
                                  setSignReligion(e.target.value)
                                }
                                value={signReligion}
                                className="form-control border-dark"
                              >
                                {getReligion.map((religion: IReligion) => {
                                  return (
                                    <option
                                      key={religion.id}
                                      value={religion.id}
                                    >
                                      {religion.religion}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>

                          <div className=" row form-group d-flex mb-4">
                            <div className="row">
                              <div className="col sec">
                                <div className="row form-row mb-3">
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="employment"
                                      className="label_text"
                                    >
                                      Select Nationality
                                    </label>
                                    <select
                                      name="selfEmploymentInformation"
                                      onChange={(e) =>
                                        setSignNationality(e.target.value)
                                      }
                                      value={signNationality}
                                      className="form-control border-dark bg-white"
                                      // placeholder="select Nationality"
                                    >
                                      <option value="" disabled hidden>select Nationality</option>
                                      {nationalityData.map((data) => {
                                        return (
                                          <option key={data.id} value={data.id}>
                                            {data.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="cerpacidNumber"
                                      className="label_text"
                                      style={{ fontSize: "0.6rem" }}
                                    >
                                      CERPAC ID number (If nationality is
                                      notNigerian)
                                    </label>
                                    <input
                                      name="cerpacidNumber"
                                      onChange={(e) =>
                                        setSignCerpacidNumber(e.target.value)
                                      }
                                      value={signCerpacidNumber}
                                      type="text"
                                      className="form-control bg-white border-dark"
                                      placeholder="eg 1234567890123"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            {/* <label className="label_text">
                              Select identity card type
                            </label>

                            <ul
                              className="nav nav-pills identity-tab mb-3 nav-fill"
                              id="pills-tab"
                              role="tablist"
                            >
                              {meansOfIdentification.map(
                                (identification: IMeansOfIdentification) => {
                                  return (
                                    <li
                                      className="nav-item"
                                      key={identification.id}
                                      onClick={() =>
                                        handleSetIdCardType(identification.text)
                                      }
                                    >
                                      <a
                                        className={`nav-link text-nowrap pl-0 pt-2 ${identification.id == 1 ? "active" : ""
                                          }`}
                                        id="pills-int-tab"
                                        data-toggle="pill"
                                        href="#pills-int"
                                        role="tab"
                                        aria-controls="pills-int"
                                        aria-selected="true"
                                      >
                                        {identification.text}
                                      </a>
                                    </li>
                                  );
                                }
                              )}
                            </ul> */}
                            <div className="tab-content" id="pills-tabContent">
                              <div
                                className="tab-pane show fade active"
                                id="1"
                                role="tabpanel"
                                aria-labelledby="pills-int-tab"
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="label_text">
                                        ID card number
                                      </label>
                                      <input
                                        name="idCardNumber"
                                        onChange={(e) =>
                                          setSignIdCardNumber(e.target.value)
                                        }
                                        value={signIdCardNumber}
                                        className="form-control border-dark"
                                        type="text"
                                        placeholder="Enter ID card number"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group identity">
                                      <label
                                        htmlFor="issuedate"
                                        className="label_text"
                                      >
                                        Issue Date
                                      </label>
                                      <DatePickerComponent
                                        value={signIssueDate}
                                        setDate={setSignIssueDate}
                                        issueYear
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="label_text">
                                        Expiry Date
                                      </label>
                                      <DatePickerComponent
                                        value={signExpiryDate}
                                        setDate={setSignExpiryDate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group mt-4 mb-4">
                            <label className="label_text">ID Card name</label>
                            <input
                              className="form-control border-dark"
                              type="text"
                              value={signIdCardName}
                              onChange={(e) =>
                                setSignIdCardName(e.target.value)
                              }
                              placeholder="Enter ID Card Name"
                            />
                          </div>

                          <div className="d-flex justify-content-end mt-4">
                            <button
                              style={{ marginRight: "10px" }}
                              className="btn btn-outline-gold mr-3 btn-filled-white"
                              onClick={previousSigantoryBusinessDetails}
                            >
                              Previous
                            </button>
                            {businessSignatoryDetailsLoading ? (
                              <div
                                className="spinner-border text-gold"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-danger btn-filled-red"
                                onClick={businessSignatoryExtraDetails}
                              >
                                Proceed
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {bvnNextMandate && (
                  <div>
                    <div className={styles.signDoubleHeader}>
                      <label htmlFor="">Mandate instruction</label>
                      <br />
                      <textarea
                        placeholder="Enter mandate instruction"
                        value={mandate}
                        onChange={(e) => setMandate(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Signature
                          </label>
                          <label
                            className="cursor-pointer"
                            htmlFor="parentofCertificateOfResgistration"
                          >
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}

                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "signature")}
                              id="parentofCertificateOfResgistration"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="col-lg-12 ml-n3">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload passport
                          </label>
                          <label className="cursor-pointer">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showBusinessSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) =>
                                handleFileUpload(e, "BusinessName")
                              }
                              id="BusinessName"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Scanned ID
                          </label>
                          <label className="cursor-pointer" htmlFor="parentof">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadScannedID ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "scannedID")}
                              id="parentof"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        style={{ marginRight: "10px" }}
                        className="btn btn-outline-goldr-3 btn-filled-white"
                        onClick={previousMandateFuntion}
                      >
                        Previous
                      </button>
                      {mandate?.length < 1 ||
                      !showBusinessSignature ||
                      !showUploadScannedID ||
                      !showUploadSignature ? (
                        <button className={styles.submit}>Add signatory</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={addedExtraSignatory}
                            >
                              Add signatory
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyOpenAccount;

//@ts-ignore

const ExampleCustomInput = React.forwardRef(({ value, onClick, ref }) => (
  <div>
    <input
      type="text"
      className="form-control border-dark bg-white"
      onClick={onClick}
      ref={ref}
      value={value}
    />
  </div>
));
